var map = {
	"./": [
		14559,
		9
	],
	"./App": [
		94689,
		9
	],
	"./App.tsx": [
		94689,
		9
	],
	"./components/LoadingSpinner/LoadingSpinner": [
		4784,
		9
	],
	"./components/LoadingSpinner/LoadingSpinner.css": [
		33579,
		9
	],
	"./components/LoadingSpinner/LoadingSpinner.tsx": [
		4784,
		9
	],
	"./components/ShimmerImage/ShimmerImage": [
		53110,
		9,
		53110
	],
	"./components/ShimmerImage/ShimmerImage.css": [
		22941,
		9,
		22941
	],
	"./components/ShimmerImage/ShimmerImage.tsx": [
		53110,
		9,
		53110
	],
	"./components/base_components/HeadingDescriptionAndImage": [
		70790,
		9,
		96213,
		70790
	],
	"./components/base_components/HeadingDescriptionAndImage.tsx": [
		70790,
		9,
		96213,
		70790
	],
	"./components/base_components/boxes/BoxItem": [
		20326,
		9,
		96213,
		20326
	],
	"./components/base_components/boxes/BoxItem.tsx": [
		20326,
		9,
		96213,
		20326
	],
	"./components/base_components/boxes/BoxListItem": [
		34238,
		9,
		34238
	],
	"./components/base_components/boxes/BoxListItem.tsx": [
		34238,
		9,
		34238
	],
	"./components/base_components/boxes/HoverCard": [
		31716,
		9,
		31716
	],
	"./components/base_components/boxes/HoverCard.tsx": [
		31716,
		9,
		31716
	],
	"./components/base_components/boxes/ListItems": [
		57052,
		9,
		96213,
		57052
	],
	"./components/base_components/boxes/ListItems.tsx": [
		57052,
		9,
		96213,
		57052
	],
	"./components/base_components/boxes/StackBoxItem": [
		33024,
		9,
		33024
	],
	"./components/base_components/boxes/StackBoxItem.tsx": [
		33024,
		9,
		33024
	],
	"./components/footer/Footer": [
		39672,
		9
	],
	"./components/footer/Footer.tsx": [
		39672,
		9
	],
	"./components/footer/footer.css": [
		77087,
		9
	],
	"./components/master_components/page_layout_sections/Pls_Listing_Audit/PlsListingAudit": [
		11424,
		9,
		96213,
		11424
	],
	"./components/master_components/page_layout_sections/Pls_Listing_Audit/PlsListingAudit.tsx": [
		11424,
		9,
		96213,
		11424
	],
	"./components/master_components/page_layout_sections/Pls_Listing_Audit/plsListingAudit.css": [
		28861,
		9,
		28861
	],
	"./components/master_components/page_layout_sections/pls_accordion_with_image/PlsAccordionWithImage": [
		46435,
		9,
		96213,
		46435
	],
	"./components/master_components/page_layout_sections/pls_accordion_with_image/PlsAccordionWithImage.tsx": [
		46435,
		9,
		96213,
		46435
	],
	"./components/master_components/page_layout_sections/pls_accordion_with_image/plsAccordionWithImage.css": [
		9984,
		9,
		9984
	],
	"./components/master_components/page_layout_sections/pls_achievement/PlsAchievement": [
		69275,
		9,
		96213,
		69275
	],
	"./components/master_components/page_layout_sections/pls_achievement/PlsAchievement.tsx": [
		69275,
		9,
		96213,
		69275
	],
	"./components/master_components/page_layout_sections/pls_achievement/plsAchievement.css": [
		20940,
		9,
		20940
	],
	"./components/master_components/page_layout_sections/pls_banner/PlsBanner": [
		60185,
		9,
		96213,
		60185
	],
	"./components/master_components/page_layout_sections/pls_banner/PlsBanner.tsx": [
		60185,
		9,
		96213,
		60185
	],
	"./components/master_components/page_layout_sections/pls_banner/plsBanner.css": [
		59706,
		9,
		59706
	],
	"./components/master_components/page_layout_sections/pls_breadcrumbs/PlsBreadCrumbs": [
		2745,
		9,
		2745
	],
	"./components/master_components/page_layout_sections/pls_breadcrumbs/PlsBreadCrumbs.tsx": [
		2745,
		9,
		2745
	],
	"./components/master_components/page_layout_sections/pls_breadcrumbs/plsBreadCrumbs.css": [
		62498,
		9,
		62498
	],
	"./components/master_components/page_layout_sections/pls_client/PlsClient": [
		87157,
		9,
		96213,
		87157
	],
	"./components/master_components/page_layout_sections/pls_client/PlsClient.tsx": [
		87157,
		9,
		96213,
		87157
	],
	"./components/master_components/page_layout_sections/pls_client/PlsClient1": [
		6188,
		9,
		96213,
		6188
	],
	"./components/master_components/page_layout_sections/pls_client/PlsClient1.tsx": [
		6188,
		9,
		96213,
		6188
	],
	"./components/master_components/page_layout_sections/pls_client/plsClient.css": [
		32078,
		9,
		32078
	],
	"./components/master_components/page_layout_sections/pls_core_section/PlsCoreSection": [
		25696,
		9,
		96213,
		25696
	],
	"./components/master_components/page_layout_sections/pls_core_section/PlsCoreSection.tsx": [
		25696,
		9,
		96213,
		25696
	],
	"./components/master_components/page_layout_sections/pls_core_section/plsCoreSection.css": [
		26341,
		9,
		26341
	],
	"./components/master_components/page_layout_sections/pls_customer_reviews/PlsCustomerReviews": [
		56944,
		9,
		96213,
		71378,
		55262,
		56944
	],
	"./components/master_components/page_layout_sections/pls_customer_reviews/PlsCustomerReviews.tsx": [
		56944,
		9,
		96213,
		71378,
		55262,
		56944
	],
	"./components/master_components/page_layout_sections/pls_customer_reviews/plsCustomerReviews.css": [
		64949,
		9,
		64949
	],
	"./components/master_components/page_layout_sections/pls_development_process_carousel/PlsDevelopmentProcessCarousel": [
		13563,
		9,
		96213,
		71378,
		88295
	],
	"./components/master_components/page_layout_sections/pls_development_process_carousel/PlsDevelopmentProcessCarousel.tsx": [
		13563,
		9,
		96213,
		71378,
		88295
	],
	"./components/master_components/page_layout_sections/pls_development_process_carousel/plsDevelopmentProcessCarousel.css": [
		55068,
		9,
		55068
	],
	"./components/master_components/page_layout_sections/pls_development_services/plsDevelopmentServices": [
		16436,
		9,
		96213,
		34462,
		16436
	],
	"./components/master_components/page_layout_sections/pls_development_services/plsDevelopmentServices.css": [
		97697,
		9,
		34462,
		97697
	],
	"./components/master_components/page_layout_sections/pls_development_services/plsDevelopmentServices.tsx": [
		16436,
		9,
		96213,
		34462,
		16436
	],
	"./components/master_components/page_layout_sections/pls_double_list/PlsDoubleList": [
		82072,
		9,
		96213,
		82072
	],
	"./components/master_components/page_layout_sections/pls_double_list/PlsDoubleList.tsx": [
		82072,
		9,
		96213,
		82072
	],
	"./components/master_components/page_layout_sections/pls_double_list/plsDoubleList.css": [
		72245,
		9,
		72245
	],
	"./components/master_components/page_layout_sections/pls_faq/PlsFAQ": [
		8293,
		9,
		96213,
		8293
	],
	"./components/master_components/page_layout_sections/pls_faq/PlsFAQ.tsx": [
		8293,
		9,
		96213,
		8293
	],
	"./components/master_components/page_layout_sections/pls_faq/plsFAQ.css": [
		53538,
		9,
		53538
	],
	"./components/master_components/page_layout_sections/pls_filter_jobs_section/PlsFilterJobsSection": [
		24689,
		9,
		96213,
		24689
	],
	"./components/master_components/page_layout_sections/pls_filter_jobs_section/PlsFilterJobsSection.tsx": [
		24689,
		9,
		96213,
		24689
	],
	"./components/master_components/page_layout_sections/pls_filter_jobs_section/plsFilterJobsSection.css": [
		32430,
		9,
		32430
	],
	"./components/master_components/page_layout_sections/pls_filters_row/PlsFiltersRow": [
		18522,
		9,
		57720,
		18522
	],
	"./components/master_components/page_layout_sections/pls_filters_row/PlsFiltersRow.tsx": [
		18522,
		9,
		57720,
		18522
	],
	"./components/master_components/page_layout_sections/pls_filters_row/plsFiltersRow.css": [
		74563,
		9,
		57720,
		74563
	],
	"./components/master_components/page_layout_sections/pls_form_data_section/PlsFormDataSection": [
		10757,
		9,
		10757
	],
	"./components/master_components/page_layout_sections/pls_form_data_section/PlsFormDataSection.tsx": [
		10757,
		9,
		10757
	],
	"./components/master_components/page_layout_sections/pls_form_data_section/plsFormDataSection.css": [
		28526,
		9,
		28526
	],
	"./components/master_components/page_layout_sections/pls_image_and_data_box/PlsImageAndDataBox": [
		9086,
		9,
		96213,
		9086
	],
	"./components/master_components/page_layout_sections/pls_image_and_data_box/PlsImageAndDataBox.tsx": [
		9086,
		9,
		96213,
		9086
	],
	"./components/master_components/page_layout_sections/pls_image_and_data_box/plsImageAndDataBox.css": [
		90331,
		9,
		90331
	],
	"./components/master_components/page_layout_sections/pls_industries_cater/PlsIndustriesCater": [
		10792,
		9,
		96213,
		71378,
		23364
	],
	"./components/master_components/page_layout_sections/pls_industries_cater/PlsIndustriesCater.tsx": [
		10792,
		9,
		96213,
		71378,
		23364
	],
	"./components/master_components/page_layout_sections/pls_industries_cater/plsIndustriesCater.css": [
		20629,
		9,
		20629
	],
	"./components/master_components/page_layout_sections/pls_industries_serve/PlsIndustriesServe": [
		73808,
		9,
		96213,
		73808
	],
	"./components/master_components/page_layout_sections/pls_industries_serve/PlsIndustriesServe.tsx": [
		73808,
		9,
		96213,
		73808
	],
	"./components/master_components/page_layout_sections/pls_industries_serve/plsIndustriesServe.css": [
		19897,
		9,
		19897
	],
	"./components/master_components/page_layout_sections/pls_info_services/PlsInfoServices": [
		31962,
		9,
		96213,
		31962
	],
	"./components/master_components/page_layout_sections/pls_info_services/PlsInfoServices.tsx": [
		31962,
		9,
		96213,
		31962
	],
	"./components/master_components/page_layout_sections/pls_info_services/plsInfoServices.css": [
		66079,
		9,
		66079
	],
	"./components/master_components/page_layout_sections/pls_labelled_image/PlsLabelledImage": [
		31952,
		9,
		96213,
		31952
	],
	"./components/master_components/page_layout_sections/pls_labelled_image/PlsLabelledImage.tsx": [
		31952,
		9,
		96213,
		31952
	],
	"./components/master_components/page_layout_sections/pls_labelled_image/plsLabelledImage.css": [
		46361,
		9,
		46361
	],
	"./components/master_components/page_layout_sections/pls_list_item_image/PlsListItemImage": [
		82821,
		9,
		96213,
		82821
	],
	"./components/master_components/page_layout_sections/pls_list_item_image/PlsListItemImage.tsx": [
		82821,
		9,
		96213,
		82821
	],
	"./components/master_components/page_layout_sections/pls_list_item_image/PlsListItemImage1": [
		56220,
		9,
		96213,
		56220
	],
	"./components/master_components/page_layout_sections/pls_list_item_image/PlsListItemImage1.tsx": [
		56220,
		9,
		96213,
		56220
	],
	"./components/master_components/page_layout_sections/pls_list_item_image/plsListItemImage.css": [
		98666,
		9,
		98666
	],
	"./components/master_components/page_layout_sections/pls_live_gallery_carousel/PlsLiveGalleryCarousel": [
		20721,
		9,
		96213,
		71378,
		46685
	],
	"./components/master_components/page_layout_sections/pls_live_gallery_carousel/PlsLiveGalleryCarousel.tsx": [
		20721,
		9,
		96213,
		71378,
		46685
	],
	"./components/master_components/page_layout_sections/pls_live_gallery_carousel/plsLiveGalleryCarousel.css": [
		98270,
		9,
		98270
	],
	"./components/master_components/page_layout_sections/pls_map_section/PlsMapSection": [
		38452,
		9,
		96213,
		38452
	],
	"./components/master_components/page_layout_sections/pls_map_section/PlsMapSection.tsx": [
		38452,
		9,
		96213,
		38452
	],
	"./components/master_components/page_layout_sections/pls_map_section/plsMapSection.css": [
		44349,
		9,
		44349
	],
	"./components/master_components/page_layout_sections/pls_nav_scroll_section/PlsNavScrollSection": [
		58445,
		9,
		96213,
		58445
	],
	"./components/master_components/page_layout_sections/pls_nav_scroll_section/PlsNavScrollSection.tsx": [
		58445,
		9,
		96213,
		58445
	],
	"./components/master_components/page_layout_sections/pls_nav_scroll_section/plsNavScrollSection.css": [
		65890,
		9,
		65890
	],
	"./components/master_components/page_layout_sections/pls_orange_border/PlsOrangeBorder": [
		73234,
		9,
		96213,
		73234
	],
	"./components/master_components/page_layout_sections/pls_orange_border/PlsOrangeBorder.tsx": [
		73234,
		9,
		96213,
		73234
	],
	"./components/master_components/page_layout_sections/pls_orange_border/plsOrangeBorder.css": [
		107,
		9,
		107
	],
	"./components/master_components/page_layout_sections/pls_our_team_carousel/PlsOurTeamCarousel": [
		54327,
		9,
		96213,
		71378,
		843
	],
	"./components/master_components/page_layout_sections/pls_our_team_carousel/PlsOurTeamCarousel.tsx": [
		54327,
		9,
		96213,
		71378,
		843
	],
	"./components/master_components/page_layout_sections/pls_our_team_carousel/plsOurTeamCarousel.css": [
		46728,
		9,
		46728
	],
	"./components/master_components/page_layout_sections/pls_paragraph_sections/PlsParagraphSections": [
		41928,
		9,
		96213,
		41928
	],
	"./components/master_components/page_layout_sections/pls_paragraph_sections/PlsParagraphSections.tsx": [
		41928,
		9,
		96213,
		41928
	],
	"./components/master_components/page_layout_sections/pls_paragraph_sections/plsParagraphSections.css": [
		40205,
		9,
		40205
	],
	"./components/master_components/page_layout_sections/pls_pricing_sections/PlsPricingSections": [
		8556,
		9,
		96213,
		8556
	],
	"./components/master_components/page_layout_sections/pls_pricing_sections/PlsPricingSections.tsx": [
		8556,
		9,
		96213,
		8556
	],
	"./components/master_components/page_layout_sections/pls_pricing_sections/plsPricingSections.css": [
		34849,
		9,
		34849
	],
	"./components/master_components/page_layout_sections/pls_progress_line/PlsProgressLine": [
		31172,
		9,
		96213,
		31172
	],
	"./components/master_components/page_layout_sections/pls_progress_line/PlsProgressLine.tsx": [
		31172,
		9,
		96213,
		31172
	],
	"./components/master_components/page_layout_sections/pls_progress_line/plsProgressLine.css": [
		87121,
		9,
		87121
	],
	"./components/master_components/page_layout_sections/pls_road_map/PlsRoadMap": [
		1874,
		9,
		96213,
		1874
	],
	"./components/master_components/page_layout_sections/pls_road_map/PlsRoadMap.tsx": [
		1874,
		9,
		96213,
		1874
	],
	"./components/master_components/page_layout_sections/pls_road_map/plsRoadMap.css": [
		6483,
		9,
		6483
	],
	"./components/master_components/page_layout_sections/pls_scroll_box/PlsScrollBox": [
		94060,
		9,
		94060
	],
	"./components/master_components/page_layout_sections/pls_scroll_box/PlsScrollBox.tsx": [
		94060,
		9,
		94060
	],
	"./components/master_components/page_layout_sections/pls_scroll_box/plsScrollBox.css": [
		47529,
		9,
		47529
	],
	"./components/master_components/page_layout_sections/pls_services_section/PlsServicesSection": [
		78240,
		9,
		96213,
		78240
	],
	"./components/master_components/page_layout_sections/pls_services_section/PlsServicesSection.tsx": [
		78240,
		9,
		96213,
		78240
	],
	"./components/master_components/page_layout_sections/pls_services_section/plsServicesSection.css": [
		52973,
		9,
		52973
	],
	"./components/master_components/page_layout_sections/pls_social_details_data/PlsSocialDetailsData": [
		83195,
		9,
		96213,
		83195
	],
	"./components/master_components/page_layout_sections/pls_social_details_data/PlsSocialDetailsData.tsx": [
		83195,
		9,
		96213,
		83195
	],
	"./components/master_components/page_layout_sections/pls_social_details_data/plsSocialDetailsData.css": [
		48332,
		9,
		48332
	],
	"./components/master_components/page_layout_sections/pls_social_hover_slider/PlsSocialHoverSlider": [
		53553,
		9,
		96213,
		53553
	],
	"./components/master_components/page_layout_sections/pls_social_hover_slider/PlsSocialHoverSlider.tsx": [
		53553,
		9,
		96213,
		53553
	],
	"./components/master_components/page_layout_sections/pls_social_hover_slider/plsSocialHoverSlider.css": [
		1798,
		9,
		1798
	],
	"./components/master_components/page_layout_sections/pls_social_row_data/PlsSocialRowData": [
		24011,
		9,
		96213,
		71378,
		64439
	],
	"./components/master_components/page_layout_sections/pls_social_row_data/PlsSocialRowData.tsx": [
		24011,
		9,
		96213,
		71378,
		64439
	],
	"./components/master_components/page_layout_sections/pls_social_row_data/plsSocialRowData.css": [
		27836,
		9,
		27836
	],
	"./components/master_components/page_layout_sections/pls_success_stories/PlsSuccessStories": [
		77278,
		9,
		96213,
		77278
	],
	"./components/master_components/page_layout_sections/pls_success_stories/PlsSuccessStories.tsx": [
		77278,
		9,
		96213,
		77278
	],
	"./components/master_components/page_layout_sections/pls_success_stories/plsSuccessStories.css": [
		35039,
		9,
		35039
	],
	"./components/master_components/page_layout_sections/pls_success_story_section/PlsSuccessStorySection": [
		64565,
		9,
		64565
	],
	"./components/master_components/page_layout_sections/pls_success_story_section/PlsSuccessStorySection.tsx": [
		64565,
		9,
		64565
	],
	"./components/master_components/page_layout_sections/pls_success_story_section/plsSuccessStorySection.css": [
		21370,
		9,
		21370
	],
	"./components/master_components/page_layout_sections/pls_tabs_section/PlsAdvancedTabsSection": [
		17962,
		9,
		96213,
		94528,
		93214
	],
	"./components/master_components/page_layout_sections/pls_tabs_section/PlsAdvancedTabsSection.tsx": [
		17962,
		9,
		96213,
		94528,
		93214
	],
	"./components/master_components/page_layout_sections/pls_tabs_section/PlsTabsSection": [
		97660,
		9,
		96213,
		94528,
		80020
	],
	"./components/master_components/page_layout_sections/pls_tabs_section/PlsTabsSection.tsx": [
		97660,
		9,
		96213,
		94528,
		80020
	],
	"./components/master_components/page_layout_sections/pls_tabs_section/plsTabsSection.css": [
		67001,
		9,
		67001
	],
	"./components/master_components/page_layout_sections/pls_tabs_slider/PlsTabsSlider": [
		8258,
		9,
		96213,
		94528,
		88486
	],
	"./components/master_components/page_layout_sections/pls_tabs_slider/PlsTabsSlider.tsx": [
		8258,
		9,
		96213,
		94528,
		88486
	],
	"./components/master_components/page_layout_sections/pls_tabs_slider/plsTabsSlider.css": [
		30147,
		9,
		30147
	],
	"./components/master_components/page_layout_sections/pls_tech_solution/PlsTechSolution": [
		16086,
		9,
		96213,
		16086
	],
	"./components/master_components/page_layout_sections/pls_tech_solution/PlsTechSolution.tsx": [
		16086,
		9,
		96213,
		16086
	],
	"./components/master_components/page_layout_sections/pls_tech_solution/plsTechSolution.css": [
		7387,
		9,
		7387
	],
	"./components/master_components/page_layout_sections/pls_technology_tools/PlsTechnologyTools": [
		70592,
		9,
		96213,
		70592
	],
	"./components/master_components/page_layout_sections/pls_technology_tools/PlsTechnologyTools.tsx": [
		70592,
		9,
		96213,
		70592
	],
	"./components/master_components/page_layout_sections/pls_technology_tools/plsTechnologyTools.css": [
		1681,
		9,
		1681
	],
	"./components/master_components/page_layout_sections/pls_vision/PlsVision": [
		11997,
		9,
		11997
	],
	"./components/master_components/page_layout_sections/pls_vision/PlsVision.tsx": [
		11997,
		9,
		11997
	],
	"./components/master_components/page_layout_sections/pls_vision/plsVision.css": [
		6206,
		9,
		6206
	],
	"./components/master_components/page_layout_sections/pls_what_we_do/PlsWhatWeDo": [
		86435,
		9,
		96213,
		86435
	],
	"./components/master_components/page_layout_sections/pls_what_we_do/PlsWhatWeDo.tsx": [
		86435,
		9,
		96213,
		86435
	],
	"./components/master_components/page_layout_sections/pls_what_we_do/plsWhatWeDo.css": [
		43384,
		9,
		43384
	],
	"./components/master_components/page_layout_sections/pls_why_choose_us/PlsWhyChooseUs": [
		17875,
		9,
		96213,
		71378,
		69519
	],
	"./components/master_components/page_layout_sections/pls_why_choose_us/PlsWhyChooseUs.tsx": [
		17875,
		9,
		96213,
		71378,
		69519
	],
	"./components/master_components/page_layout_sections/pls_why_choose_us/plsWhyChooseUs.css": [
		41108,
		9,
		41108
	],
	"./components/master_components/page_layouts/PageLayout0": [
		41444,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444
	],
	"./components/master_components/page_layouts/PageLayout0.tsx": [
		41444,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444
	],
	"./components/master_components/page_layouts/PageLayout1": [
		43553,
		9,
		96213,
		34462,
		43553,
		22429
	],
	"./components/master_components/page_layouts/PageLayout1.tsx": [
		43553,
		9,
		96213,
		34462,
		43553,
		22429
	],
	"./components/master_components/page_layouts/PageLayout2": [
		75202,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202
	],
	"./components/master_components/page_layouts/PageLayout2.tsx": [
		75202,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202
	],
	"./components/master_components/page_layouts/PageLayout3": [
		85287,
		9,
		96213,
		71378,
		34462,
		55262,
		85287
	],
	"./components/master_components/page_layouts/PageLayout3.tsx": [
		85287,
		9,
		96213,
		71378,
		34462,
		55262,
		85287
	],
	"./components/master_components/page_layouts/PageLayout4": [
		82400,
		9,
		73677,
		57720,
		82400
	],
	"./components/master_components/page_layouts/PageLayout4.tsx": [
		82400,
		9,
		73677,
		57720,
		82400
	],
	"./components/master_components/page_layouts/PageLayout5": [
		90141,
		9,
		96213,
		71378,
		34462,
		55262,
		90141,
		65048
	],
	"./components/master_components/page_layouts/PageLayout5.tsx": [
		90141,
		9,
		96213,
		71378,
		34462,
		55262,
		90141,
		65048
	],
	"./components/master_components/page_layouts/PageLayout6": [
		42286,
		9,
		96213,
		42286
	],
	"./components/master_components/page_layouts/PageLayout6.tsx": [
		42286,
		9,
		96213,
		42286
	],
	"./components/master_components/page_layouts/PageLayout7": [
		97043,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043
	],
	"./components/master_components/page_layouts/PageLayout7.tsx": [
		97043,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043
	],
	"./components/master_components/page_layouts/PageLayout8": [
		52700,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700
	],
	"./components/master_components/page_layouts/PageLayout8.tsx": [
		52700,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700
	],
	"./components/navigation/Navigation": [
		60298,
		9
	],
	"./components/navigation/Navigation.tsx": [
		60298,
		9
	],
	"./components/navigation/navigation.css": [
		74293,
		9
	],
	"./data/json/common_data/FooterData": [
		94941,
		3
	],
	"./data/json/common_data/FooterData.json": [
		94941,
		3
	],
	"./data/json/common_data/NavBarMenu": [
		73831,
		3
	],
	"./data/json/common_data/NavBarMenu.json": [
		73831,
		3
	],
	"./data/json/company/AboutUs": [
		97322,
		3,
		97322
	],
	"./data/json/company/AboutUs.json": [
		97322,
		3,
		97322
	],
	"./data/json/company/Careers": [
		63136,
		3,
		63136
	],
	"./data/json/company/Careers.json": [
		63136,
		3,
		63136
	],
	"./data/json/company/JobOpenings": [
		56721,
		3,
		56721
	],
	"./data/json/company/JobOpenings.json": [
		56721,
		3,
		56721
	],
	"./data/json/company/Social": [
		80134,
		3,
		80134
	],
	"./data/json/company/Social.json": [
		80134,
		3,
		80134
	],
	"./data/json/company/SocialDetails": [
		32152,
		3,
		32152
	],
	"./data/json/company/SocialDetails.json": [
		32152,
		3,
		32152
	],
	"./data/json/contact_us/ContactUs": [
		56287,
		3,
		56287
	],
	"./data/json/contact_us/ContactUs.json": [
		56287,
		3,
		56287
	],
	"./data/json/home/Home": [
		46580,
		3,
		46580
	],
	"./data/json/home/Home.json": [
		46580,
		3,
		46580
	],
	"./data/json/industries/Automotive": [
		27065,
		3,
		27065
	],
	"./data/json/industries/Automotive.json": [
		27065,
		3,
		27065
	],
	"./data/json/industries/Automotive/AIMachineLearning": [
		79591,
		3,
		79591
	],
	"./data/json/industries/Automotive/AIMachineLearning.json": [
		79591,
		3,
		79591
	],
	"./data/json/industries/Automotive/AutonomousADAS": [
		16523,
		3,
		16523
	],
	"./data/json/industries/Automotive/AutonomousADAS.json": [
		16523,
		3,
		16523
	],
	"./data/json/industries/Automotive/ConnectedCars": [
		65538,
		3,
		65538
	],
	"./data/json/industries/Automotive/ConnectedCars.json": [
		65538,
		3,
		65538
	],
	"./data/json/industries/Automotive/EVChargingSoftware": [
		34915,
		3,
		34915
	],
	"./data/json/industries/Automotive/EVChargingSoftware.json": [
		34915,
		3,
		34915
	],
	"./data/json/industries/Automotive/HMI": [
		56012,
		3,
		56012
	],
	"./data/json/industries/Automotive/HMI.json": [
		56012,
		3,
		56012
	],
	"./data/json/industries/Automotive/NavigationMapping": [
		39758,
		3,
		39758
	],
	"./data/json/industries/Automotive/NavigationMapping.json": [
		39758,
		3,
		39758
	],
	"./data/json/industries/Automotive/Security": [
		50896,
		3,
		50896
	],
	"./data/json/industries/Automotive/Security.json": [
		50896,
		3,
		50896
	],
	"./data/json/industries/Automotive/SmartBikes": [
		45303,
		3,
		45303
	],
	"./data/json/industries/Automotive/SmartBikes.json": [
		45303,
		3,
		45303
	],
	"./data/json/industries/Automotive/Telematics": [
		93721,
		3,
		93721
	],
	"./data/json/industries/Automotive/Telematics.json": [
		93721,
		3,
		93721
	],
	"./data/json/industries/BFSI": [
		26732,
		3,
		26732
	],
	"./data/json/industries/BFSI.json": [
		26732,
		3,
		26732
	],
	"./data/json/industries/EnergyAndMining": [
		26129,
		3,
		26129
	],
	"./data/json/industries/EnergyAndMining.json": [
		26129,
		3,
		26129
	],
	"./data/json/industries/FoodAndBeverages": [
		82085,
		3,
		82085
	],
	"./data/json/industries/FoodAndBeverages.json": [
		82085,
		3,
		82085
	],
	"./data/json/industries/Healthcare": [
		72027,
		3,
		72027
	],
	"./data/json/industries/Healthcare.json": [
		72027,
		3,
		72027
	],
	"./data/json/industries/Healthcare/Dashboard": [
		71872,
		3,
		71872
	],
	"./data/json/industries/Healthcare/Dashboard.json": [
		71872,
		3,
		71872
	],
	"./data/json/industries/Healthcare/HMS": [
		65280,
		3,
		42899
	],
	"./data/json/industries/Healthcare/HMS.json": [
		65280,
		3,
		42899
	],
	"./data/json/industries/Healthcare/Iot": [
		74396,
		3,
		74396
	],
	"./data/json/industries/Healthcare/Iot.json": [
		74396,
		3,
		74396
	],
	"./data/json/industries/Healthcare/MobileHealthcare": [
		65225,
		3,
		65225
	],
	"./data/json/industries/Healthcare/MobileHealthcare.json": [
		65225,
		3,
		65225
	],
	"./data/json/industries/Healthcare/MobileLearning": [
		4440,
		3,
		4440
	],
	"./data/json/industries/Healthcare/MobileLearning.json": [
		4440,
		3,
		4440
	],
	"./data/json/industries/Healthcare/Simulation": [
		27579,
		3,
		27579
	],
	"./data/json/industries/Healthcare/Simulation.json": [
		27579,
		3,
		27579
	],
	"./data/json/industries/Healthcare/Wearables": [
		96448,
		3,
		96448
	],
	"./data/json/industries/Healthcare/Wearables.json": [
		96448,
		3,
		96448
	],
	"./data/json/industries/Industries": [
		95814,
		3,
		95814
	],
	"./data/json/industries/Industries.json": [
		95814,
		3,
		95814
	],
	"./data/json/industries/Manufacturing": [
		58146,
		3,
		58146
	],
	"./data/json/industries/Manufacturing.json": [
		58146,
		3,
		58146
	],
	"./data/json/industries/Manufacturing/SupplyChainManagementSolution": [
		76453,
		3,
		76453
	],
	"./data/json/industries/Manufacturing/SupplyChainManagementSolution.json": [
		76453,
		3,
		76453
	],
	"./data/json/industries/Manufacturing/TransportationManagement": [
		41394,
		3,
		41394
	],
	"./data/json/industries/Manufacturing/TransportationManagement.json": [
		41394,
		3,
		41394
	],
	"./data/json/industries/Manufacturing/WarehouseManagementSolution": [
		33442,
		3,
		33442
	],
	"./data/json/industries/Manufacturing/WarehouseManagementSolution.json": [
		33442,
		3,
		33442
	],
	"./data/json/industries/MediaAndEntertainment": [
		74169,
		3,
		74169
	],
	"./data/json/industries/MediaAndEntertainment.json": [
		74169,
		3,
		74169
	],
	"./data/json/industries/MediaAndEntertainment/DigitalAssestManagementSolutions": [
		40102,
		3,
		40102
	],
	"./data/json/industries/MediaAndEntertainment/DigitalAssestManagementSolutions.json": [
		40102,
		3,
		40102
	],
	"./data/json/industries/MediaAndEntertainment/EnterpriseContentManagementSolutions": [
		98707,
		3,
		98707
	],
	"./data/json/industries/MediaAndEntertainment/EnterpriseContentManagementSolutions.json": [
		98707,
		3,
		98707
	],
	"./data/json/industries/MediaAndEntertainment/OTTSoftwareSolutions": [
		27818,
		3,
		27818
	],
	"./data/json/industries/MediaAndEntertainment/OTTSoftwareSolutions.json": [
		27818,
		3,
		27818
	],
	"./data/json/industries/RealEstate": [
		98304,
		3,
		98304
	],
	"./data/json/industries/RealEstate.json": [
		98304,
		3,
		98304
	],
	"./data/json/industries/Retail": [
		76651,
		3,
		76651
	],
	"./data/json/industries/Retail.json": [
		76651,
		3,
		76651
	],
	"./data/json/industries/Retail/B2BCommerceSolutions": [
		36891,
		3,
		36891
	],
	"./data/json/industries/Retail/B2BCommerceSolutions.json": [
		36891,
		3,
		36891
	],
	"./data/json/industries/Retail/B2CCommerceSolutions": [
		88214,
		3,
		88214
	],
	"./data/json/industries/Retail/B2CCommerceSolutions.json": [
		88214,
		3,
		88214
	],
	"./data/json/industries/Retail/DealershipManagementSolutions": [
		68080,
		3,
		68080
	],
	"./data/json/industries/Retail/DealershipManagementSolutions.json": [
		68080,
		3,
		68080
	],
	"./data/json/industries/Retail/LeadManagementSystem": [
		36512,
		3,
		36512
	],
	"./data/json/industries/Retail/LeadManagementSystem.json": [
		36512,
		3,
		36512
	],
	"./data/json/industries/Retail/ProductInformationManagement": [
		33868,
		3,
		33868
	],
	"./data/json/industries/Retail/ProductInformationManagement.json": [
		33868,
		3,
		33868
	],
	"./data/json/industries/Retail/SalesforceAutomationSolutions": [
		8572,
		3,
		8572
	],
	"./data/json/industries/Retail/SalesforceAutomationSolutions.json": [
		8572,
		3,
		8572
	],
	"./data/json/industries/Technology": [
		20434,
		3,
		20434
	],
	"./data/json/industries/Technology.json": [
		20434,
		3,
		20434
	],
	"./data/json/industries/Transportation": [
		28502,
		3,
		28502
	],
	"./data/json/industries/Transportation.json": [
		28502,
		3,
		28502
	],
	"./data/json/portfolio/AISolutions": [
		38958,
		3,
		38958
	],
	"./data/json/portfolio/AISolutions.json": [
		38958,
		3,
		38958
	],
	"./data/json/portfolio/MobileApps": [
		91882,
		3,
		91882
	],
	"./data/json/portfolio/MobileApps.json": [
		91882,
		3,
		91882
	],
	"./data/json/portfolio/SmartApplications": [
		64914,
		3,
		64914
	],
	"./data/json/portfolio/SmartApplications.json": [
		64914,
		3,
		64914
	],
	"./data/json/portfolio/SocialCommunities": [
		81488,
		3,
		81488
	],
	"./data/json/portfolio/SocialCommunities.json": [
		81488,
		3,
		81488
	],
	"./data/json/portfolio/WebPortfolio": [
		8786,
		3,
		8786
	],
	"./data/json/portfolio/WebPortfolio.json": [
		8786,
		3,
		8786
	],
	"./data/json/services/Services": [
		43418,
		3,
		43418
	],
	"./data/json/services/Services.json": [
		43418,
		3,
		43418
	],
	"./data/json/services/automation/Automation": [
		33669,
		3,
		33669
	],
	"./data/json/services/automation/Automation.json": [
		33669,
		3,
		33669
	],
	"./data/json/services/automation/HRAutomation": [
		18647,
		3,
		18647
	],
	"./data/json/services/automation/HRAutomation.json": [
		18647,
		3,
		18647
	],
	"./data/json/services/automation/IntelligentAutomation": [
		2828,
		3,
		2828
	],
	"./data/json/services/automation/IntelligentAutomation.json": [
		2828,
		3,
		2828
	],
	"./data/json/services/automation/ProcessAutomation": [
		48532,
		3,
		48532
	],
	"./data/json/services/automation/ProcessAutomation.json": [
		48532,
		3,
		48532
	],
	"./data/json/services/automation/SalesMarketingAutomation": [
		66349,
		3,
		66349
	],
	"./data/json/services/automation/SalesMarketingAutomation.json": [
		66349,
		3,
		66349
	],
	"./data/json/services/custom_framework/CustomFramework": [
		90144,
		3,
		90144
	],
	"./data/json/services/custom_framework/CustomFramework.json": [
		90144,
		3,
		90144
	],
	"./data/json/services/custom_framework/Dotnet": [
		37309,
		3,
		37309
	],
	"./data/json/services/custom_framework/Dotnet.json": [
		37309,
		3,
		37309
	],
	"./data/json/services/custom_framework/Java": [
		18795,
		3,
		18795
	],
	"./data/json/services/custom_framework/Java.json": [
		18795,
		3,
		18795
	],
	"./data/json/services/custom_framework/Nodejs": [
		86144,
		3,
		86144
	],
	"./data/json/services/custom_framework/Nodejs.json": [
		86144,
		3,
		86144
	],
	"./data/json/services/custom_framework/PHP": [
		56589,
		3,
		56589
	],
	"./data/json/services/custom_framework/PHP.json": [
		56589,
		3,
		56589
	],
	"./data/json/services/dashboard_development/DashboardDevelopment": [
		57108,
		3,
		57108
	],
	"./data/json/services/dashboard_development/DashboardDevelopment.json": [
		57108,
		3,
		57108
	],
	"./data/json/services/dashboard_development/DashboardsForManagement": [
		75976,
		3,
		75976
	],
	"./data/json/services/dashboard_development/DashboardsForManagement.json": [
		75976,
		3,
		75976
	],
	"./data/json/services/dashboard_development/EnterpriseDashboard": [
		65498,
		3,
		65498
	],
	"./data/json/services/dashboard_development/EnterpriseDashboard.json": [
		65498,
		3,
		65498
	],
	"./data/json/services/dashboard_development/FinanceDashboard": [
		92311,
		3,
		92311
	],
	"./data/json/services/dashboard_development/FinanceDashboard.json": [
		92311,
		3,
		92311
	],
	"./data/json/services/dashboard_development/HRDashboard": [
		69969,
		3,
		69969
	],
	"./data/json/services/dashboard_development/HRDashboard.json": [
		69969,
		3,
		69969
	],
	"./data/json/services/dashboard_development/MarketingDashboard": [
		22625,
		3,
		22625
	],
	"./data/json/services/dashboard_development/MarketingDashboard.json": [
		22625,
		3,
		22625
	],
	"./data/json/services/dashboard_development/OperationalDashboard": [
		34837,
		3,
		34837
	],
	"./data/json/services/dashboard_development/OperationalDashboard.json": [
		34837,
		3,
		34837
	],
	"./data/json/services/dashboard_development/ProjectManagementDashboard": [
		48319,
		3,
		48319
	],
	"./data/json/services/dashboard_development/ProjectManagementDashboard.json": [
		48319,
		3,
		48319
	],
	"./data/json/services/dashboard_development/SalesDashboard": [
		45097,
		3,
		45097
	],
	"./data/json/services/dashboard_development/SalesDashboard.json": [
		45097,
		3,
		45097
	],
	"./data/json/services/dev_ops/CloudDevOpsServices": [
		49801,
		3,
		49801
	],
	"./data/json/services/dev_ops/CloudDevOpsServices.json": [
		49801,
		3,
		49801
	],
	"./data/json/services/dev_ops/CloudSupportService": [
		61754,
		3,
		61754
	],
	"./data/json/services/dev_ops/CloudSupportService.json": [
		61754,
		3,
		61754
	],
	"./data/json/services/dev_ops/CyberSecurity": [
		84958,
		3,
		84958
	],
	"./data/json/services/dev_ops/CyberSecurity.json": [
		84958,
		3,
		84958
	],
	"./data/json/services/dev_ops/DevOps": [
		83450,
		3,
		83450
	],
	"./data/json/services/dev_ops/DevOps.json": [
		83450,
		3,
		83450
	],
	"./data/json/services/dev_ops/DevOpsAccessementService": [
		226,
		3,
		226
	],
	"./data/json/services/dev_ops/DevOpsAccessementService.json": [
		226,
		3,
		226
	],
	"./data/json/services/dev_ops/DevOpsAutomation": [
		47341,
		3,
		47341
	],
	"./data/json/services/dev_ops/DevOpsAutomation.json": [
		47341,
		3,
		47341
	],
	"./data/json/services/dev_ops/DevOpsImplementationService": [
		17951,
		3,
		17951
	],
	"./data/json/services/dev_ops/DevOpsImplementationService.json": [
		17951,
		3,
		17951
	],
	"./data/json/services/dev_ops/DevOpsMonitoring": [
		41296,
		3,
		41296
	],
	"./data/json/services/dev_ops/DevOpsMonitoring.json": [
		41296,
		3,
		41296
	],
	"./data/json/services/dev_ops/DevSecOps": [
		30621,
		3,
		30621
	],
	"./data/json/services/dev_ops/DevSecOps.json": [
		30621,
		3,
		30621
	],
	"./data/json/services/dev_ops/SiteReliabilityEngineering": [
		21663,
		3,
		21663
	],
	"./data/json/services/dev_ops/SiteReliabilityEngineering.json": [
		21663,
		3,
		21663
	],
	"./data/json/services/digital_marketing/ContentMarketing": [
		67185,
		3,
		67185
	],
	"./data/json/services/digital_marketing/ContentMarketing.json": [
		67185,
		3,
		67185
	],
	"./data/json/services/digital_marketing/DigitalMarketing": [
		28758,
		3,
		28758
	],
	"./data/json/services/digital_marketing/DigitalMarketing.json": [
		28758,
		3,
		28758
	],
	"./data/json/services/digital_marketing/ORM": [
		29542,
		3,
		29542
	],
	"./data/json/services/digital_marketing/ORM.json": [
		29542,
		3,
		29542
	],
	"./data/json/services/digital_marketing/SEO": [
		21379,
		3,
		21379
	],
	"./data/json/services/digital_marketing/SEO.json": [
		21379,
		3,
		21379
	],
	"./data/json/services/digital_marketing/SMO": [
		19083,
		3,
		19083
	],
	"./data/json/services/digital_marketing/SMO.json": [
		19083,
		3,
		19083
	],
	"./data/json/services/e_commerce/B2BCommerce": [
		18551,
		3,
		18551
	],
	"./data/json/services/e_commerce/B2BCommerce.json": [
		18551,
		3,
		18551
	],
	"./data/json/services/e_commerce/B2CCommerce": [
		60564,
		3,
		60564
	],
	"./data/json/services/e_commerce/B2CCommerce.json": [
		60564,
		3,
		60564
	],
	"./data/json/services/e_commerce/ChatGptIntegration": [
		63161,
		3,
		63161
	],
	"./data/json/services/e_commerce/ChatGptIntegration.json": [
		63161,
		3,
		63161
	],
	"./data/json/services/e_commerce/Customization": [
		29879,
		3,
		29879
	],
	"./data/json/services/e_commerce/Customization.json": [
		29879,
		3,
		29879
	],
	"./data/json/services/e_commerce/Omnichannel": [
		61830,
		3,
		61830
	],
	"./data/json/services/e_commerce/Omnichannel.json": [
		61830,
		3,
		61830
	],
	"./data/json/services/e_commerce/eCommerce": [
		86798,
		3,
		86798
	],
	"./data/json/services/e_commerce/eCommerce.json": [
		86798,
		3,
		86798
	],
	"./data/json/services/emerging_tech/AI": [
		6216,
		3,
		6216
	],
	"./data/json/services/emerging_tech/AI.json": [
		6216,
		3,
		6216
	],
	"./data/json/services/emerging_tech/BlockChain": [
		66196,
		3,
		66196
	],
	"./data/json/services/emerging_tech/BlockChain.json": [
		66196,
		3,
		66196
	],
	"./data/json/services/emerging_tech/DataAnalytics": [
		65670,
		3,
		65670
	],
	"./data/json/services/emerging_tech/DataAnalytics.json": [
		65670,
		3,
		65670
	],
	"./data/json/services/emerging_tech/EmergingTech": [
		36248,
		3,
		36248
	],
	"./data/json/services/emerging_tech/EmergingTech.json": [
		36248,
		3,
		36248
	],
	"./data/json/services/emerging_tech/MachineLearning": [
		57541,
		3,
		57541
	],
	"./data/json/services/emerging_tech/MachineLearning.json": [
		57541,
		3,
		57541
	],
	"./data/json/services/enterprise_digital_transformation/EnterpriseDigitalTransformation": [
		98841,
		3,
		98841
	],
	"./data/json/services/enterprise_digital_transformation/EnterpriseDigitalTransformation.json": [
		98841,
		3,
		98841
	],
	"./data/json/services/enterprise_digital_transformation/EnterpriseSoftwareSolution": [
		9190,
		3,
		9190
	],
	"./data/json/services/enterprise_digital_transformation/EnterpriseSoftwareSolution.json": [
		9190,
		3,
		9190
	],
	"./data/json/services/enterprise_digital_transformation/MetaverseDevelopment": [
		63076,
		3,
		63076
	],
	"./data/json/services/enterprise_digital_transformation/MetaverseDevelopment.json": [
		63076,
		3,
		63076
	],
	"./data/json/services/enterprise_digital_transformation/ProcessHarmonization": [
		80601,
		3,
		80601
	],
	"./data/json/services/enterprise_digital_transformation/ProcessHarmonization.json": [
		80601,
		3,
		80601
	],
	"./data/json/services/enterprise_digital_transformation/SalesforceSolution": [
		86931,
		3,
		86931
	],
	"./data/json/services/enterprise_digital_transformation/SalesforceSolution.json": [
		86931,
		3,
		86931
	],
	"./data/json/services/enterprise_digital_transformation/WorkFlowSolution": [
		6641,
		3,
		6641
	],
	"./data/json/services/enterprise_digital_transformation/WorkFlowSolution.json": [
		6641,
		3,
		6641
	],
	"./data/json/services/iot/ConnectedTech": [
		30586,
		3,
		30586
	],
	"./data/json/services/iot/ConnectedTech.json": [
		30586,
		3,
		30586
	],
	"./data/json/services/iot/FacilityMonitoring": [
		11804,
		3,
		11804
	],
	"./data/json/services/iot/FacilityMonitoring.json": [
		11804,
		3,
		11804
	],
	"./data/json/services/iot/IndustrialIoT": [
		30320,
		3,
		30320
	],
	"./data/json/services/iot/IndustrialIoT.json": [
		30320,
		3,
		30320
	],
	"./data/json/services/iot/IoT": [
		38933,
		3,
		38933
	],
	"./data/json/services/iot/IoT.json": [
		38933,
		3,
		38933
	],
	"./data/json/services/iot/IoTIntegration": [
		80349,
		3,
		80349
	],
	"./data/json/services/iot/IoTIntegration.json": [
		80349,
		3,
		80349
	],
	"./data/json/services/mobile_apps/Hybrid": [
		67200,
		3,
		67200
	],
	"./data/json/services/mobile_apps/Hybrid.json": [
		67200,
		3,
		67200
	],
	"./data/json/services/mobile_apps/MobileAndroid": [
		55043,
		3,
		55043
	],
	"./data/json/services/mobile_apps/MobileAndroid.json": [
		55043,
		3,
		55043
	],
	"./data/json/services/mobile_apps/MobileApps": [
		34060,
		3,
		34060
	],
	"./data/json/services/mobile_apps/MobileApps.json": [
		34060,
		3,
		34060
	],
	"./data/json/services/mobile_apps/MobileIos": [
		33757,
		3,
		33757
	],
	"./data/json/services/mobile_apps/MobileIos.json": [
		33757,
		3,
		33757
	],
	"./data/json/services/mobile_apps/PWAS": [
		78311,
		3,
		78311
	],
	"./data/json/services/mobile_apps/PWAS.json": [
		78311,
		3,
		78311
	],
	"./data/json/services/product_engineering/ProductApplicationCatalogue": [
		37870,
		3,
		37870
	],
	"./data/json/services/product_engineering/ProductApplicationCatalogue.json": [
		37870,
		3,
		37870
	],
	"./data/json/services/product_engineering/ProductDesign": [
		89347,
		3,
		89347
	],
	"./data/json/services/product_engineering/ProductDesign.json": [
		89347,
		3,
		89347
	],
	"./data/json/services/product_engineering/ProductDevelopment": [
		46714,
		3,
		46714
	],
	"./data/json/services/product_engineering/ProductDevelopment.json": [
		46714,
		3,
		46714
	],
	"./data/json/services/product_engineering/ProductEngineering": [
		9820,
		3,
		9820
	],
	"./data/json/services/product_engineering/ProductEngineering.json": [
		9820,
		3,
		9820
	],
	"./data/json/services/product_engineering/SolutionArchitecture": [
		17954,
		3,
		17954
	],
	"./data/json/services/product_engineering/SolutionArchitecture.json": [
		17954,
		3,
		17954
	],
	"./data/json/services/product_engineering/TechSupport": [
		8217,
		3,
		8217
	],
	"./data/json/services/product_engineering/TechSupport.json": [
		8217,
		3,
		8217
	],
	"./data/json/services/prototyping_uI_ux/HighFidelity": [
		54413,
		3,
		54413
	],
	"./data/json/services/prototyping_uI_ux/HighFidelity.json": [
		54413,
		3,
		54413
	],
	"./data/json/services/prototyping_uI_ux/LowFidelity": [
		55561,
		3,
		55561
	],
	"./data/json/services/prototyping_uI_ux/LowFidelity.json": [
		55561,
		3,
		55561
	],
	"./data/json/services/prototyping_uI_ux/MVPs": [
		48065,
		3,
		48065
	],
	"./data/json/services/prototyping_uI_ux/MVPs.json": [
		48065,
		3,
		48065
	],
	"./data/json/services/prototyping_uI_ux/ProtoTypingUiUx": [
		66655,
		3,
		66655
	],
	"./data/json/services/prototyping_uI_ux/ProtoTypingUiUx.json": [
		66655,
		3,
		66655
	],
	"./data/json/services/prototyping_uI_ux/RapidPrototype": [
		96171,
		3,
		96171
	],
	"./data/json/services/prototyping_uI_ux/RapidPrototype.json": [
		96171,
		3,
		96171
	],
	"./data/json/services/prototyping_uI_ux/UiUxDesign": [
		65102,
		3,
		65102
	],
	"./data/json/services/prototyping_uI_ux/UiUxDesign.json": [
		65102,
		3,
		65102
	],
	"./data/json/services/testing_qa/AutomationTesting": [
		49247,
		3,
		49247
	],
	"./data/json/services/testing_qa/AutomationTesting.json": [
		49247,
		3,
		49247
	],
	"./data/json/services/testing_qa/FunctionalTesting": [
		36361,
		3,
		36361
	],
	"./data/json/services/testing_qa/FunctionalTesting.json": [
		36361,
		3,
		36361
	],
	"./data/json/services/testing_qa/ManualTesting": [
		74644,
		3,
		52263
	],
	"./data/json/services/testing_qa/ManualTesting.json": [
		74644,
		3,
		52263
	],
	"./data/json/services/testing_qa/TestingQA": [
		82328,
		3,
		82328
	],
	"./data/json/services/testing_qa/TestingQA.json": [
		82328,
		3,
		82328
	],
	"./data/json/services/testing_qa/VAPT": [
		76671,
		3,
		76671
	],
	"./data/json/services/testing_qa/VAPT.json": [
		76671,
		3,
		76671
	],
	"./data/json/staff_augmentation/Staffaugmentation": [
		17695,
		3,
		17695
	],
	"./data/json/staff_augmentation/Staffaugmentation.json": [
		17695,
		3,
		17695
	],
	"./data/json/staff_augmentation/backend/Backend": [
		73242,
		3,
		73242
	],
	"./data/json/staff_augmentation/backend/Backend.json": [
		73242,
		3,
		73242
	],
	"./data/json/staff_augmentation/backend/DotNet": [
		87932,
		3,
		87932
	],
	"./data/json/staff_augmentation/backend/DotNet.json": [
		87932,
		3,
		87932
	],
	"./data/json/staff_augmentation/backend/GraphQL": [
		8463,
		3,
		8463
	],
	"./data/json/staff_augmentation/backend/GraphQL.json": [
		8463,
		3,
		8463
	],
	"./data/json/staff_augmentation/backend/Java": [
		38310,
		3,
		38310
	],
	"./data/json/staff_augmentation/backend/Java.json": [
		38310,
		3,
		38310
	],
	"./data/json/staff_augmentation/backend/Php": [
		86410,
		3,
		86410
	],
	"./data/json/staff_augmentation/backend/Php.json": [
		86410,
		3,
		86410
	],
	"./data/json/staff_augmentation/backend/Python": [
		53292,
		3,
		53292
	],
	"./data/json/staff_augmentation/backend/Python.json": [
		53292,
		3,
		53292
	],
	"./data/json/staff_augmentation/cms/CMS": [
		40922,
		3,
		40922
	],
	"./data/json/staff_augmentation/cms/CMS.json": [
		40922,
		3,
		40922
	],
	"./data/json/staff_augmentation/cms/Drupal": [
		20007,
		3,
		20007
	],
	"./data/json/staff_augmentation/cms/Drupal.json": [
		20007,
		3,
		20007
	],
	"./data/json/staff_augmentation/cms/Kentico": [
		3392,
		3,
		3392
	],
	"./data/json/staff_augmentation/cms/Kentico.json": [
		3392,
		3,
		3392
	],
	"./data/json/staff_augmentation/cms/Magento": [
		19874,
		3,
		19874
	],
	"./data/json/staff_augmentation/cms/Magento.json": [
		19874,
		3,
		19874
	],
	"./data/json/staff_augmentation/cms/Sitecore": [
		62497,
		3,
		62497
	],
	"./data/json/staff_augmentation/cms/Sitecore.json": [
		62497,
		3,
		62497
	],
	"./data/json/staff_augmentation/cms/WordPress": [
		93072,
		3,
		93072
	],
	"./data/json/staff_augmentation/cms/WordPress.json": [
		93072,
		3,
		93072
	],
	"./data/json/staff_augmentation/devops/AWS": [
		74460,
		3,
		74460
	],
	"./data/json/staff_augmentation/devops/AWS.json": [
		74460,
		3,
		74460
	],
	"./data/json/staff_augmentation/devops/Azure": [
		69842,
		3,
		69842
	],
	"./data/json/staff_augmentation/devops/Azure.json": [
		69842,
		3,
		69842
	],
	"./data/json/staff_augmentation/devops/Cybersecurity": [
		50310,
		3,
		50310
	],
	"./data/json/staff_augmentation/devops/Cybersecurity.json": [
		50310,
		3,
		50310
	],
	"./data/json/staff_augmentation/devops/DevOps": [
		97746,
		3,
		97746
	],
	"./data/json/staff_augmentation/devops/DevOps.json": [
		97746,
		3,
		97746
	],
	"./data/json/staff_augmentation/devops/GCP": [
		63851,
		3,
		63851
	],
	"./data/json/staff_augmentation/devops/GCP.json": [
		63851,
		3,
		63851
	],
	"./data/json/staff_augmentation/ecommerce/Drupal": [
		36036,
		3,
		36036
	],
	"./data/json/staff_augmentation/ecommerce/Drupal.json": [
		36036,
		3,
		36036
	],
	"./data/json/staff_augmentation/ecommerce/Magento": [
		36783,
		3,
		36783
	],
	"./data/json/staff_augmentation/ecommerce/Magento.json": [
		36783,
		3,
		36783
	],
	"./data/json/staff_augmentation/ecommerce/Shopify": [
		69660,
		3,
		69660
	],
	"./data/json/staff_augmentation/ecommerce/Shopify.json": [
		69660,
		3,
		69660
	],
	"./data/json/staff_augmentation/ecommerce/WooCommerce": [
		43482,
		3,
		43482
	],
	"./data/json/staff_augmentation/ecommerce/WooCommerce.json": [
		43482,
		3,
		43482
	],
	"./data/json/staff_augmentation/ecommerce/eCommerce": [
		79698,
		3,
		79698
	],
	"./data/json/staff_augmentation/ecommerce/eCommerce.json": [
		79698,
		3,
		79698
	],
	"./data/json/staff_augmentation/enterprise/BigData": [
		65293,
		3,
		65293
	],
	"./data/json/staff_augmentation/enterprise/BigData.json": [
		65293,
		3,
		65293
	],
	"./data/json/staff_augmentation/enterprise/DevOps": [
		94248,
		3,
		94248
	],
	"./data/json/staff_augmentation/enterprise/DevOps.json": [
		94248,
		3,
		94248
	],
	"./data/json/staff_augmentation/enterprise/Enterprise": [
		96830,
		3,
		96830
	],
	"./data/json/staff_augmentation/enterprise/Enterprise.json": [
		96830,
		3,
		96830
	],
	"./data/json/staff_augmentation/enterprise/Salesforce": [
		85854,
		3,
		85854
	],
	"./data/json/staff_augmentation/enterprise/Salesforce.json": [
		85854,
		3,
		85854
	],
	"./data/json/staff_augmentation/enterprise/SharePoint": [
		17946,
		3,
		17946
	],
	"./data/json/staff_augmentation/enterprise/SharePoint.json": [
		17946,
		3,
		17946
	],
	"./data/json/staff_augmentation/frontend/Angular": [
		83242,
		3,
		83242
	],
	"./data/json/staff_augmentation/frontend/Angular.json": [
		83242,
		3,
		83242
	],
	"./data/json/staff_augmentation/frontend/Frontend": [
		75212,
		3,
		75212
	],
	"./data/json/staff_augmentation/frontend/Frontend.json": [
		75212,
		3,
		75212
	],
	"./data/json/staff_augmentation/frontend/HtmlAndCss": [
		79969,
		3,
		79969
	],
	"./data/json/staff_augmentation/frontend/HtmlAndCss.json": [
		79969,
		3,
		79969
	],
	"./data/json/staff_augmentation/frontend/React": [
		76871,
		3,
		76871
	],
	"./data/json/staff_augmentation/frontend/React.json": [
		76871,
		3,
		76871
	],
	"./data/json/staff_augmentation/frontend/Vuejs": [
		43367,
		3,
		43367
	],
	"./data/json/staff_augmentation/frontend/Vuejs.json": [
		43367,
		3,
		43367
	],
	"./data/json/staff_augmentation/js/AngularJs": [
		77522,
		3,
		77522
	],
	"./data/json/staff_augmentation/js/AngularJs.json": [
		77522,
		3,
		77522
	],
	"./data/json/staff_augmentation/js/JS": [
		69662,
		3,
		69662
	],
	"./data/json/staff_augmentation/js/JS.json": [
		69662,
		3,
		69662
	],
	"./data/json/staff_augmentation/js/NodeJs": [
		1910,
		3,
		1910
	],
	"./data/json/staff_augmentation/js/NodeJs.json": [
		1910,
		3,
		1910
	],
	"./data/json/staff_augmentation/js/ReactJs": [
		80171,
		3,
		80171
	],
	"./data/json/staff_augmentation/js/ReactJs.json": [
		80171,
		3,
		80171
	],
	"./data/json/staff_augmentation/js/VueJs": [
		41400,
		3,
		41400
	],
	"./data/json/staff_augmentation/js/VueJs.json": [
		41400,
		3,
		41400
	],
	"./data/json/staff_augmentation/mobile/Android": [
		95777,
		3,
		95777
	],
	"./data/json/staff_augmentation/mobile/Android.json": [
		95777,
		3,
		95777
	],
	"./data/json/staff_augmentation/mobile/Flutter": [
		95616,
		3,
		95616
	],
	"./data/json/staff_augmentation/mobile/Flutter.json": [
		95616,
		3,
		95616
	],
	"./data/json/staff_augmentation/mobile/IoS": [
		85247,
		3,
		85247
	],
	"./data/json/staff_augmentation/mobile/IoS.json": [
		85247,
		3,
		85247
	],
	"./data/json/staff_augmentation/mobile/Mobile": [
		8752,
		3,
		8752
	],
	"./data/json/staff_augmentation/mobile/Mobile.json": [
		8752,
		3,
		8752
	],
	"./data/json/staff_augmentation/mobile/ReactNative": [
		95530,
		3,
		95530
	],
	"./data/json/staff_augmentation/mobile/ReactNative.json": [
		95530,
		3,
		95530
	],
	"./data/json/staff_augmentation/ops/AgileCoaches": [
		32840,
		3,
		32840
	],
	"./data/json/staff_augmentation/ops/AgileCoaches.json": [
		32840,
		3,
		32840
	],
	"./data/json/staff_augmentation/ops/HRProfessionals": [
		76172,
		3,
		76172
	],
	"./data/json/staff_augmentation/ops/HRProfessionals.json": [
		76172,
		3,
		76172
	],
	"./data/json/staff_augmentation/ops/Ops": [
		7202,
		3,
		7202
	],
	"./data/json/staff_augmentation/ops/Ops.json": [
		7202,
		3,
		7202
	],
	"./data/json/staff_augmentation/ops/ProjectManagers": [
		31407,
		3,
		31407
	],
	"./data/json/staff_augmentation/ops/ProjectManagers.json": [
		31407,
		3,
		31407
	],
	"./data/json/staff_augmentation/ops/ScrumMasters": [
		9671,
		3,
		9671
	],
	"./data/json/staff_augmentation/ops/ScrumMasters.json": [
		9671,
		3,
		9671
	],
	"./data/json/staff_augmentation/qa/Automation": [
		50205,
		3,
		50205
	],
	"./data/json/staff_augmentation/qa/Automation.json": [
		50205,
		3,
		50205
	],
	"./data/json/staff_augmentation/qa/Manual": [
		17776,
		3,
		17776
	],
	"./data/json/staff_augmentation/qa/Manual.json": [
		17776,
		3,
		17776
	],
	"./data/json/staff_augmentation/qa/Qa": [
		16636,
		3,
		16636
	],
	"./data/json/staff_augmentation/qa/Qa.json": [
		16636,
		3,
		16636
	],
	"./data/json/staff_augmentation/web/Drupal": [
		10506,
		3,
		10506
	],
	"./data/json/staff_augmentation/web/Drupal.json": [
		10506,
		3,
		10506
	],
	"./data/json/staff_augmentation/web/Laravel": [
		23021,
		3,
		23021
	],
	"./data/json/staff_augmentation/web/Laravel.json": [
		23021,
		3,
		23021
	],
	"./data/json/staff_augmentation/web/PHP": [
		5444,
		3,
		5444
	],
	"./data/json/staff_augmentation/web/PHP.json": [
		5444,
		3,
		5444
	],
	"./data/json/staff_augmentation/web/Python": [
		53530,
		3,
		53530
	],
	"./data/json/staff_augmentation/web/Python.json": [
		53530,
		3,
		53530
	],
	"./data/json/staff_augmentation/web/Web": [
		72606,
		3,
		72606
	],
	"./data/json/staff_augmentation/web/Web.json": [
		72606,
		3,
		72606
	],
	"./data/json/staff_augmentation/web/WordPress": [
		24875,
		3,
		24875
	],
	"./data/json/staff_augmentation/web/WordPress.json": [
		24875,
		3,
		24875
	],
	"./data/json/success_stories/SuccessStories": [
		88107,
		3,
		88107
	],
	"./data/json/success_stories/SuccessStories.json": [
		88107,
		3,
		88107
	],
	"./data/json/technologies/Technologies": [
		46018,
		3,
		46018
	],
	"./data/json/technologies/Technologies.json": [
		46018,
		3,
		46018
	],
	"./data/json/technologies/cloud_devops_devse_ops/AWSCloudSolution": [
		80616,
		3,
		80616
	],
	"./data/json/technologies/cloud_devops_devse_ops/AWSCloudSolution.json": [
		80616,
		3,
		80616
	],
	"./data/json/technologies/cloud_devops_devse_ops/AWSManagedServices": [
		46475,
		3,
		46475
	],
	"./data/json/technologies/cloud_devops_devse_ops/AWSManagedServices.json": [
		46475,
		3,
		46475
	],
	"./data/json/technologies/cloud_devops_devse_ops/AzureCloudSolution": [
		68114,
		3,
		68114
	],
	"./data/json/technologies/cloud_devops_devse_ops/AzureCloudSolution.json": [
		68114,
		3,
		68114
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudArchitecture": [
		73161,
		3,
		73161
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudArchitecture.json": [
		73161,
		3,
		73161
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudDevOpsDevSecOps": [
		1253,
		3,
		1253
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudDevOpsDevSecOps.json": [
		1253,
		3,
		1253
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudHosting": [
		42036,
		3,
		42036
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudHosting.json": [
		42036,
		3,
		42036
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudMigration": [
		71534,
		3,
		71534
	],
	"./data/json/technologies/cloud_devops_devse_ops/CloudMigration.json": [
		71534,
		3,
		71534
	],
	"./data/json/technologies/cloud_devops_devse_ops/CyberSecurity": [
		15384,
		3,
		15384
	],
	"./data/json/technologies/cloud_devops_devse_ops/CyberSecurity.json": [
		15384,
		3,
		15384
	],
	"./data/json/technologies/cloud_devops_devse_ops/DevOpsEngineering": [
		33975,
		3,
		33975
	],
	"./data/json/technologies/cloud_devops_devse_ops/DevOpsEngineering.json": [
		33975,
		3,
		33975
	],
	"./data/json/technologies/cloud_devops_devse_ops/GCPSolution": [
		5638,
		3,
		5638
	],
	"./data/json/technologies/cloud_devops_devse_ops/GCPSolution.json": [
		5638,
		3,
		5638
	],
	"./data/json/technologies/cloud_devops_devse_ops/VAPT": [
		63184,
		3,
		63184
	],
	"./data/json/technologies/cloud_devops_devse_ops/VAPT.json": [
		63184,
		3,
		63184
	],
	"./data/json/technologies/content_management_system/BigCommerce": [
		93337,
		3,
		93337
	],
	"./data/json/technologies/content_management_system/BigCommerce.json": [
		93337,
		3,
		93337
	],
	"./data/json/technologies/content_management_system/CSCart": [
		28928,
		3,
		28928
	],
	"./data/json/technologies/content_management_system/CSCart.json": [
		28928,
		3,
		28928
	],
	"./data/json/technologies/content_management_system/ContentManagementSystem": [
		56139,
		3,
		56139
	],
	"./data/json/technologies/content_management_system/ContentManagementSystem.json": [
		56139,
		3,
		56139
	],
	"./data/json/technologies/content_management_system/Drupal": [
		1274,
		3,
		1274
	],
	"./data/json/technologies/content_management_system/Drupal.json": [
		1274,
		3,
		1274
	],
	"./data/json/technologies/content_management_system/HeadlessDevelopment": [
		85356,
		3,
		85356
	],
	"./data/json/technologies/content_management_system/HeadlessDevelopment.json": [
		85356,
		3,
		85356
	],
	"./data/json/technologies/content_management_system/Magento": [
		69577,
		3,
		69577
	],
	"./data/json/technologies/content_management_system/Magento.json": [
		69577,
		3,
		69577
	],
	"./data/json/technologies/content_management_system/OpenCart": [
		29742,
		3,
		29742
	],
	"./data/json/technologies/content_management_system/OpenCart.json": [
		29742,
		3,
		29742
	],
	"./data/json/technologies/content_management_system/Prestashop": [
		9937,
		3,
		9937
	],
	"./data/json/technologies/content_management_system/Prestashop.json": [
		9937,
		3,
		9937
	],
	"./data/json/technologies/content_management_system/Shopify": [
		83838,
		3,
		83838
	],
	"./data/json/technologies/content_management_system/Shopify.json": [
		83838,
		3,
		83838
	],
	"./data/json/technologies/content_management_system/WooCommerce": [
		24148,
		3,
		24148
	],
	"./data/json/technologies/content_management_system/WooCommerce.json": [
		24148,
		3,
		24148
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessDrupal": [
		66531,
		3,
		66531
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessDrupal.json": [
		66531,
		3,
		66531
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessMagento": [
		46318,
		3,
		46318
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessMagento.json": [
		46318,
		3,
		46318
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessOpenCart": [
		93803,
		3,
		93803
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessOpenCart.json": [
		93803,
		3,
		93803
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessPrestashop": [
		96556,
		3,
		96556
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessPrestashop.json": [
		96556,
		3,
		96556
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessShopify": [
		94349,
		3,
		94349
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessShopify.json": [
		94349,
		3,
		94349
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessWooCommerce": [
		68303,
		3,
		68303
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessWooCommerce.json": [
		68303,
		3,
		68303
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessWordPress": [
		24396,
		3,
		24396
	],
	"./data/json/technologies/content_management_system/headless_development/HeadlessWordPress.json": [
		24396,
		3,
		24396
	],
	"./data/json/technologies/custom_application_development/CRM": [
		60591,
		3,
		60591
	],
	"./data/json/technologies/custom_application_development/CRM.json": [
		60591,
		3,
		60591
	],
	"./data/json/technologies/custom_application_development/CustomApplicationDevelopment": [
		17097,
		3,
		17097
	],
	"./data/json/technologies/custom_application_development/CustomApplicationDevelopment.json": [
		17097,
		3,
		17097
	],
	"./data/json/technologies/custom_application_development/DigitalSalesSolution": [
		32598,
		3,
		32598
	],
	"./data/json/technologies/custom_application_development/DigitalSalesSolution.json": [
		32598,
		3,
		32598
	],
	"./data/json/technologies/custom_application_development/ERP": [
		45238,
		3,
		45238
	],
	"./data/json/technologies/custom_application_development/ERP.json": [
		45238,
		3,
		45238
	],
	"./data/json/technologies/custom_application_development/HRMS": [
		5679,
		3,
		5679
	],
	"./data/json/technologies/custom_application_development/HRMS.json": [
		5679,
		3,
		5679
	],
	"./data/json/technologies/custom_application_development/HubspotCRMCustomization": [
		48861,
		3,
		48861
	],
	"./data/json/technologies/custom_application_development/HubspotCRMCustomization.json": [
		48861,
		3,
		48861
	],
	"./data/json/technologies/custom_application_development/LMS": [
		17851,
		3,
		17851
	],
	"./data/json/technologies/custom_application_development/LMS.json": [
		17851,
		3,
		17851
	],
	"./data/json/technologies/custom_application_development/ProcessHarmonizationSolution": [
		18368,
		3,
		18368
	],
	"./data/json/technologies/custom_application_development/ProcessHarmonizationSolution.json": [
		18368,
		3,
		18368
	],
	"./data/json/technologies/custom_application_development/SFAs": [
		69308,
		3,
		69308
	],
	"./data/json/technologies/custom_application_development/SFAs.json": [
		69308,
		3,
		69308
	],
	"./data/json/technologies/custom_application_development/WorkflowManagementSolution": [
		21204,
		3,
		21204
	],
	"./data/json/technologies/custom_application_development/WorkflowManagementSolution.json": [
		21204,
		3,
		21204
	],
	"./data/json/technologies/emerging_technologies/ArtificalIntelligence": [
		28498,
		3,
		28498
	],
	"./data/json/technologies/emerging_technologies/ArtificalIntelligence.json": [
		28498,
		3,
		28498
	],
	"./data/json/technologies/emerging_technologies/BigData": [
		9268,
		3,
		9268
	],
	"./data/json/technologies/emerging_technologies/BigData.json": [
		9268,
		3,
		9268
	],
	"./data/json/technologies/emerging_technologies/ChatGpt": [
		89505,
		3,
		89505
	],
	"./data/json/technologies/emerging_technologies/ChatGpt.json": [
		89505,
		3,
		89505
	],
	"./data/json/technologies/emerging_technologies/EmergingTechnologies": [
		47974,
		3,
		47974
	],
	"./data/json/technologies/emerging_technologies/EmergingTechnologies.json": [
		47974,
		3,
		47974
	],
	"./data/json/technologies/emerging_technologies/IOT": [
		8230,
		3,
		8230
	],
	"./data/json/technologies/emerging_technologies/IOT.json": [
		8230,
		3,
		8230
	],
	"./data/json/technologies/emerging_technologies/MachineLearning": [
		74029,
		3,
		74029
	],
	"./data/json/technologies/emerging_technologies/MachineLearning.json": [
		74029,
		3,
		74029
	],
	"./data/json/technologies/emerging_technologies/MachineLearningOperations": [
		59856,
		3,
		37475
	],
	"./data/json/technologies/emerging_technologies/MachineLearningOperations.json": [
		59856,
		3,
		37475
	],
	"./data/json/technologies/emerging_technologies/NaturalLanguageProcessing": [
		70166,
		3,
		70166
	],
	"./data/json/technologies/emerging_technologies/NaturalLanguageProcessing.json": [
		70166,
		3,
		70166
	],
	"./data/json/technologies/emerging_technologies/Rpa": [
		71867,
		3,
		71867
	],
	"./data/json/technologies/emerging_technologies/Rpa.json": [
		71867,
		3,
		71867
	],
	"./data/json/technologies/emerging_technologies/block_chain/BlockChain": [
		38492,
		3,
		38492
	],
	"./data/json/technologies/emerging_technologies/block_chain/BlockChain.json": [
		38492,
		3,
		38492
	],
	"./data/json/technologies/emerging_technologies/block_chain/CryptoCurrency": [
		54292,
		3,
		54292
	],
	"./data/json/technologies/emerging_technologies/block_chain/CryptoCurrency.json": [
		54292,
		3,
		54292
	],
	"./data/json/technologies/emerging_technologies/block_chain/DAppDevelopment": [
		83274,
		3,
		83274
	],
	"./data/json/technologies/emerging_technologies/block_chain/DAppDevelopment.json": [
		83274,
		3,
		83274
	],
	"./data/json/technologies/emerging_technologies/block_chain/IcoSolutions": [
		86377,
		3,
		86377
	],
	"./data/json/technologies/emerging_technologies/block_chain/IcoSolutions.json": [
		86377,
		3,
		86377
	],
	"./data/json/technologies/emerging_technologies/block_chain/IeoSolutions": [
		61027,
		3,
		61027
	],
	"./data/json/technologies/emerging_technologies/block_chain/IeoSolutions.json": [
		61027,
		3,
		61027
	],
	"./data/json/technologies/emerging_technologies/block_chain/StoSolutions": [
		63782,
		3,
		63782
	],
	"./data/json/technologies/emerging_technologies/block_chain/StoSolutions.json": [
		63782,
		3,
		63782
	],
	"./data/json/technologies/enterprise_application_development/ApplicationDevelopmentMaintenance": [
		38093,
		3,
		38093
	],
	"./data/json/technologies/enterprise_application_development/ApplicationDevelopmentMaintenance.json": [
		38093,
		3,
		38093
	],
	"./data/json/technologies/enterprise_application_development/Dashboard": [
		16895,
		3,
		16895
	],
	"./data/json/technologies/enterprise_application_development/Dashboard.json": [
		16895,
		3,
		16895
	],
	"./data/json/technologies/enterprise_application_development/EnterpriseApplicationDevelopment": [
		74073,
		3,
		74073
	],
	"./data/json/technologies/enterprise_application_development/EnterpriseApplicationDevelopment.json": [
		74073,
		3,
		74073
	],
	"./data/json/technologies/enterprise_application_development/EnterpriseSoftwareSolutions": [
		27253,
		3,
		27253
	],
	"./data/json/technologies/enterprise_application_development/EnterpriseSoftwareSolutions.json": [
		27253,
		3,
		27253
	],
	"./data/json/technologies/enterprise_application_development/HeadlessDevelopment": [
		98571,
		3,
		98571
	],
	"./data/json/technologies/enterprise_application_development/HeadlessDevelopment.json": [
		98571,
		3,
		98571
	],
	"./data/json/technologies/enterprise_application_development/ProcessHarmonization": [
		21459,
		3,
		21459
	],
	"./data/json/technologies/enterprise_application_development/ProcessHarmonization.json": [
		21459,
		3,
		21459
	],
	"./data/json/technologies/enterprise_application_development/SalesforceSolutions": [
		38110,
		3,
		38110
	],
	"./data/json/technologies/enterprise_application_development/SalesforceSolutions.json": [
		38110,
		3,
		38110
	],
	"./data/json/technologies/enterprise_application_development/SharePointDevelopment": [
		13811,
		3,
		13811
	],
	"./data/json/technologies/enterprise_application_development/SharePointDevelopment.json": [
		13811,
		3,
		13811
	],
	"./data/json/technologies/enterprise_application_development/SoftwareProductDevelopment": [
		44824,
		3,
		44824
	],
	"./data/json/technologies/enterprise_application_development/SoftwareProductDevelopment.json": [
		44824,
		3,
		44824
	],
	"./data/json/technologies/enterprise_application_development/TableauDashboards": [
		30276,
		3,
		30276
	],
	"./data/json/technologies/enterprise_application_development/TableauDashboards.json": [
		30276,
		3,
		30276
	],
	"./data/json/technologies/enterprise_application_development/WorkflowSolutions": [
		600,
		3,
		600
	],
	"./data/json/technologies/enterprise_application_development/WorkflowSolutions.json": [
		600,
		3,
		600
	],
	"./data/json/technologies/enterprise_application_development/dashboard/DashboardsForManagement": [
		6787,
		3,
		6787
	],
	"./data/json/technologies/enterprise_application_development/dashboard/DashboardsForManagement.json": [
		6787,
		3,
		6787
	],
	"./data/json/technologies/enterprise_application_development/dashboard/EnterpriseDashboard": [
		95269,
		3,
		95269
	],
	"./data/json/technologies/enterprise_application_development/dashboard/EnterpriseDashboard.json": [
		95269,
		3,
		95269
	],
	"./data/json/technologies/enterprise_application_development/dashboard/FinanceDashboard": [
		3922,
		3,
		3922
	],
	"./data/json/technologies/enterprise_application_development/dashboard/FinanceDashboard.json": [
		3922,
		3,
		3922
	],
	"./data/json/technologies/enterprise_application_development/dashboard/HRDashboard": [
		56914,
		3,
		56914
	],
	"./data/json/technologies/enterprise_application_development/dashboard/HRDashboard.json": [
		56914,
		3,
		56914
	],
	"./data/json/technologies/enterprise_application_development/dashboard/MarketingDashboard": [
		44308,
		3,
		44308
	],
	"./data/json/technologies/enterprise_application_development/dashboard/MarketingDashboard.json": [
		44308,
		3,
		44308
	],
	"./data/json/technologies/enterprise_application_development/dashboard/OperationalDashboard": [
		48928,
		3,
		48928
	],
	"./data/json/technologies/enterprise_application_development/dashboard/OperationalDashboard.json": [
		48928,
		3,
		48928
	],
	"./data/json/technologies/enterprise_application_development/dashboard/ProjectManagementDashboard": [
		62394,
		3,
		62394
	],
	"./data/json/technologies/enterprise_application_development/dashboard/ProjectManagementDashboard.json": [
		62394,
		3,
		62394
	],
	"./data/json/technologies/enterprise_application_development/dashboard/SalesDashboard": [
		35556,
		3,
		35556
	],
	"./data/json/technologies/enterprise_application_development/dashboard/SalesDashboard.json": [
		35556,
		3,
		35556
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceImplementation": [
		20459,
		3,
		20459
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceImplementation.json": [
		20459,
		3,
		20459
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceIntegration": [
		28549,
		3,
		28549
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceIntegration.json": [
		28549,
		3,
		28549
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceManagedServices": [
		41306,
		3,
		41306
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceManagedServices.json": [
		41306,
		3,
		41306
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceSalesCloud": [
		17816,
		3,
		17816
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceSalesCloud.json": [
		17816,
		3,
		17816
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceServiceCloud": [
		70469,
		3,
		70469
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/SalesforceServiceCloud.json": [
		70469,
		3,
		70469
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2BCommerceSolution": [
		65756,
		3,
		65756
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2BCommerceSolution.json": [
		65756,
		3,
		65756
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2CCommerceSolution": [
		18767,
		3,
		18767
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2CCommerceSolution.json": [
		18767,
		3,
		18767
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/DealershipManagementSolutions": [
		11290,
		3,
		11290
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/DealershipManagementSolutions.json": [
		11290,
		3,
		11290
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/LeadManagementSystem": [
		91498,
		3,
		91498
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/LeadManagementSystem.json": [
		91498,
		3,
		91498
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/ProductInformationManagement": [
		22170,
		3,
		22170
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/ProductInformationManagement.json": [
		22170,
		3,
		22170
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/SalesforceAutomation": [
		35498,
		3,
		35498
	],
	"./data/json/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/SalesforceAutomation.json": [
		35498,
		3,
		35498
	],
	"./data/json/technologies/microsoft_technologies/Azure": [
		99591,
		3,
		99591
	],
	"./data/json/technologies/microsoft_technologies/Azure.json": [
		99591,
		3,
		99591
	],
	"./data/json/technologies/microsoft_technologies/Copilot": [
		31576,
		3,
		31576
	],
	"./data/json/technologies/microsoft_technologies/Copilot.json": [
		31576,
		3,
		31576
	],
	"./data/json/technologies/microsoft_technologies/DotNet": [
		98158,
		3,
		98158
	],
	"./data/json/technologies/microsoft_technologies/DotNet.json": [
		98158,
		3,
		98158
	],
	"./data/json/technologies/microsoft_technologies/Dynamics365": [
		28542,
		3,
		28542
	],
	"./data/json/technologies/microsoft_technologies/Dynamics365.json": [
		28542,
		3,
		28542
	],
	"./data/json/technologies/microsoft_technologies/MicrosoftTechnologies": [
		87210,
		3,
		87210
	],
	"./data/json/technologies/microsoft_technologies/MicrosoftTechnologies.json": [
		87210,
		3,
		87210
	],
	"./data/json/technologies/microsoft_technologies/PowerApps": [
		40101,
		3,
		40101
	],
	"./data/json/technologies/microsoft_technologies/PowerApps.json": [
		40101,
		3,
		40101
	],
	"./data/json/technologies/microsoft_technologies/PowerPlatform": [
		32882,
		3,
		32882
	],
	"./data/json/technologies/microsoft_technologies/PowerPlatform.json": [
		32882,
		3,
		32882
	],
	"./data/json/technologies/microsoft_technologies/SharePoint": [
		53011,
		3,
		53011
	],
	"./data/json/technologies/microsoft_technologies/SharePoint.json": [
		53011,
		3,
		53011
	],
	"./data/json/technologies/mobile_application_development/Android": [
		73097,
		3,
		73097
	],
	"./data/json/technologies/mobile_application_development/Android.json": [
		73097,
		3,
		73097
	],
	"./data/json/technologies/mobile_application_development/CrossPlatformApplications": [
		90606,
		3,
		90606
	],
	"./data/json/technologies/mobile_application_development/CrossPlatformApplications.json": [
		90606,
		3,
		90606
	],
	"./data/json/technologies/mobile_application_development/HybridApp/FlutterApp": [
		56577,
		3,
		56577
	],
	"./data/json/technologies/mobile_application_development/HybridApp/FlutterApp.json": [
		56577,
		3,
		56577
	],
	"./data/json/technologies/mobile_application_development/HybridApp/HybridApp": [
		96321,
		3,
		96321
	],
	"./data/json/technologies/mobile_application_development/HybridApp/HybridApp.json": [
		96321,
		3,
		96321
	],
	"./data/json/technologies/mobile_application_development/HybridApp/IonicApp": [
		58701,
		3,
		58701
	],
	"./data/json/technologies/mobile_application_development/HybridApp/IonicApp.json": [
		58701,
		3,
		58701
	],
	"./data/json/technologies/mobile_application_development/HybridApp/NativeScriptApp": [
		29159,
		3,
		29159
	],
	"./data/json/technologies/mobile_application_development/HybridApp/NativeScriptApp.json": [
		29159,
		3,
		29159
	],
	"./data/json/technologies/mobile_application_development/HybridApp/PhoneGapApps": [
		38696,
		3,
		38696
	],
	"./data/json/technologies/mobile_application_development/HybridApp/PhoneGapApps.json": [
		38696,
		3,
		38696
	],
	"./data/json/technologies/mobile_application_development/HybridApp/ReactNativeApp": [
		89767,
		3,
		89767
	],
	"./data/json/technologies/mobile_application_development/HybridApp/ReactNativeApp.json": [
		89767,
		3,
		89767
	],
	"./data/json/technologies/mobile_application_development/HybridApp/SenchaApps": [
		21252,
		3,
		21252
	],
	"./data/json/technologies/mobile_application_development/HybridApp/SenchaApps.json": [
		21252,
		3,
		21252
	],
	"./data/json/technologies/mobile_application_development/HybridApp/TizenApps": [
		62120,
		3,
		62120
	],
	"./data/json/technologies/mobile_application_development/HybridApp/TizenApps.json": [
		62120,
		3,
		62120
	],
	"./data/json/technologies/mobile_application_development/HybridApp/XamarinApp": [
		77509,
		3,
		77509
	],
	"./data/json/technologies/mobile_application_development/HybridApp/XamarinApp.json": [
		77509,
		3,
		77509
	],
	"./data/json/technologies/mobile_application_development/Ios": [
		80439,
		3,
		80439
	],
	"./data/json/technologies/mobile_application_development/Ios.json": [
		80439,
		3,
		80439
	],
	"./data/json/technologies/mobile_application_development/Kotlin": [
		72719,
		3,
		72719
	],
	"./data/json/technologies/mobile_application_development/Kotlin.json": [
		72719,
		3,
		72719
	],
	"./data/json/technologies/mobile_application_development/MobileApplicationDevelopment": [
		46887,
		3,
		46887
	],
	"./data/json/technologies/mobile_application_development/MobileApplicationDevelopment.json": [
		46887,
		3,
		46887
	],
	"./data/json/technologies/mobile_application_development/MobileMaintenanceSupport": [
		86958,
		3,
		86958
	],
	"./data/json/technologies/mobile_application_development/MobileMaintenanceSupport.json": [
		86958,
		3,
		86958
	],
	"./data/json/technologies/mobile_application_development/PWAS": [
		49267,
		3,
		49267
	],
	"./data/json/technologies/mobile_application_development/PWAS.json": [
		49267,
		3,
		49267
	],
	"./data/json/technologies/web_application_development/AngularJS": [
		335,
		3,
		335
	],
	"./data/json/technologies/web_application_development/AngularJS.json": [
		335,
		3,
		335
	],
	"./data/json/technologies/web_application_development/CakePHP": [
		26190,
		3,
		26190
	],
	"./data/json/technologies/web_application_development/CakePHP.json": [
		26190,
		3,
		26190
	],
	"./data/json/technologies/web_application_development/CodeIgniter": [
		53613,
		3,
		53613
	],
	"./data/json/technologies/web_application_development/CodeIgniter.json": [
		53613,
		3,
		53613
	],
	"./data/json/technologies/web_application_development/DotNet": [
		24164,
		3,
		24164
	],
	"./data/json/technologies/web_application_development/DotNet.json": [
		24164,
		3,
		24164
	],
	"./data/json/technologies/web_application_development/ExpressJs": [
		15281,
		3,
		15281
	],
	"./data/json/technologies/web_application_development/ExpressJs.json": [
		15281,
		3,
		15281
	],
	"./data/json/technologies/web_application_development/Java": [
		66110,
		3,
		66110
	],
	"./data/json/technologies/web_application_development/Java.json": [
		66110,
		3,
		66110
	],
	"./data/json/technologies/web_application_development/KnockoutJS": [
		75957,
		3,
		75957
	],
	"./data/json/technologies/web_application_development/KnockoutJS.json": [
		75957,
		3,
		75957
	],
	"./data/json/technologies/web_application_development/Laravel": [
		30331,
		3,
		30331
	],
	"./data/json/technologies/web_application_development/Laravel.json": [
		30331,
		3,
		30331
	],
	"./data/json/technologies/web_application_development/MEAN": [
		29487,
		3,
		29487
	],
	"./data/json/technologies/web_application_development/MEAN.json": [
		29487,
		3,
		29487
	],
	"./data/json/technologies/web_application_development/Mern": [
		69864,
		3,
		69864
	],
	"./data/json/technologies/web_application_development/Mern.json": [
		69864,
		3,
		69864
	],
	"./data/json/technologies/web_application_development/MeteorJS": [
		61325,
		3,
		61325
	],
	"./data/json/technologies/web_application_development/MeteorJS.json": [
		61325,
		3,
		61325
	],
	"./data/json/technologies/web_application_development/NodeJS": [
		79881,
		3,
		79881
	],
	"./data/json/technologies/web_application_development/NodeJS.json": [
		79881,
		3,
		79881
	],
	"./data/json/technologies/web_application_development/Php": [
		98962,
		3,
		98962
	],
	"./data/json/technologies/web_application_development/Php.json": [
		98962,
		3,
		98962
	],
	"./data/json/technologies/web_application_development/Python": [
		58132,
		3,
		58132
	],
	"./data/json/technologies/web_application_development/Python.json": [
		58132,
		3,
		58132
	],
	"./data/json/technologies/web_application_development/ReactJS": [
		51166,
		3,
		51166
	],
	"./data/json/technologies/web_application_development/ReactJS.json": [
		51166,
		3,
		51166
	],
	"./data/json/technologies/web_application_development/Salesforce": [
		17233,
		3,
		17233
	],
	"./data/json/technologies/web_application_development/Salesforce.json": [
		17233,
		3,
		17233
	],
	"./data/json/technologies/web_application_development/Sharepoint": [
		6033,
		3,
		6033
	],
	"./data/json/technologies/web_application_development/Sharepoint.json": [
		6033,
		3,
		6033
	],
	"./data/json/technologies/web_application_development/VueJS": [
		22157,
		3,
		22157
	],
	"./data/json/technologies/web_application_development/VueJS.json": [
		22157,
		3,
		22157
	],
	"./data/json/technologies/web_application_development/WebApplicationDevelopment": [
		16387,
		3,
		16387
	],
	"./data/json/technologies/web_application_development/WebApplicationDevelopment.json": [
		16387,
		3,
		16387
	],
	"./functions/CommonUtils": [
		28682,
		9,
		28682
	],
	"./functions/CommonUtils.tsx": [
		28682,
		9,
		28682
	],
	"./functions/RoutesConfig": [
		31214,
		9
	],
	"./functions/RoutesConfig.tsx": [
		31214,
		9
	],
	"./functions/ScrollToTop": [
		19197,
		9
	],
	"./functions/ScrollToTop.tsx": [
		19197,
		9
	],
	"./hooks/useIsMobile": [
		46852,
		9,
		46852
	],
	"./hooks/useIsMobile.ts": [
		46852,
		9,
		46852
	],
	"./index": [
		14559,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.tsx": [
		14559,
		9
	],
	"./models/enum/ComponentNames": [
		71794,
		9,
		71794
	],
	"./models/enum/ComponentNames.ts": [
		71794,
		9,
		71794
	],
	"./models/enum/SectionNames": [
		87102,
		9,
		87102
	],
	"./models/enum/SectionNames.ts": [
		87102,
		9,
		87102
	],
	"./models/types/DynamicComponentPropInterface": [
		399,
		9,
		399
	],
	"./models/types/DynamicComponentPropInterface.ts": [
		399,
		9,
		399
	],
	"./models/types/NavBarMenu": [
		91006,
		9,
		91006
	],
	"./models/types/NavBarMenu.ts": [
		91006,
		9,
		91006
	],
	"./models/types/PageLayoutTypes": [
		28573,
		9,
		28573
	],
	"./models/types/PageLayoutTypes.ts": [
		28573,
		9,
		28573
	],
	"./models/types/root_types/ContentDataTypes": [
		1694,
		9,
		1694
	],
	"./models/types/root_types/ContentDataTypes.ts": [
		1694,
		9,
		1694
	],
	"./models/types/root_types/IImageDetails": [
		52263,
		9,
		74644
	],
	"./models/types/root_types/IImageDetails.ts": [
		52263,
		9,
		74644
	],
	"./pages/company/AboutUs": [
		79280,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		79280
	],
	"./pages/company/AboutUs.tsx": [
		79280,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		79280
	],
	"./pages/company/Careers": [
		63990,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		63990
	],
	"./pages/company/Careers.tsx": [
		63990,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		63990
	],
	"./pages/company/JobOpenings": [
		96565,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		96565
	],
	"./pages/company/JobOpenings.tsx": [
		96565,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		96565
	],
	"./pages/company/Social": [
		28254,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		28254
	],
	"./pages/company/Social.tsx": [
		28254,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		28254
	],
	"./pages/company/SocialDetails": [
		42846,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		42846
	],
	"./pages/company/SocialDetails.tsx": [
		42846,
		9,
		96213,
		71378,
		42626,
		34462,
		55262,
		97043,
		42846
	],
	"./pages/contact_us/ContactUs": [
		71061,
		9,
		96213,
		71378,
		34462,
		55262,
		90141,
		16820
	],
	"./pages/contact_us/ContactUs.tsx": [
		71061,
		9,
		96213,
		71378,
		34462,
		55262,
		90141,
		16820
	],
	"./pages/home/Home": [
		85002,
		9,
		96213,
		34462,
		43553,
		65472
	],
	"./pages/home/Home.tsx": [
		85002,
		9,
		96213,
		34462,
		43553,
		65472
	],
	"./pages/industries/Automotive": [
		10273,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		10273
	],
	"./pages/industries/Automotive.tsx": [
		10273,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		10273
	],
	"./pages/industries/BFSI": [
		80706,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		80706
	],
	"./pages/industries/BFSI.tsx": [
		80706,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		80706
	],
	"./pages/industries/EnergyAndMining": [
		5943,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		5943
	],
	"./pages/industries/EnergyAndMining.tsx": [
		5943,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		5943
	],
	"./pages/industries/FoodAndBeverages": [
		19561,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		19561
	],
	"./pages/industries/FoodAndBeverages.tsx": [
		19561,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		19561
	],
	"./pages/industries/Healthcare": [
		25055,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		25055
	],
	"./pages/industries/Healthcare.tsx": [
		25055,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		25055
	],
	"./pages/industries/Healthcare/Dashboard": [
		96266,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		96266
	],
	"./pages/industries/Healthcare/Dashboard.tsx": [
		96266,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		96266
	],
	"./pages/industries/Healthcare/HMS": [
		55134,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		55134
	],
	"./pages/industries/Healthcare/HMS.tsx": [
		55134,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		55134
	],
	"./pages/industries/Healthcare/Iot": [
		64062,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		64062
	],
	"./pages/industries/Healthcare/Iot.tsx": [
		64062,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		64062
	],
	"./pages/industries/Healthcare/MobileHealthcare": [
		93303,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		93303
	],
	"./pages/industries/Healthcare/MobileHealthcare.tsx": [
		93303,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		93303
	],
	"./pages/industries/Healthcare/MobileLearning": [
		92864,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		92864
	],
	"./pages/industries/Healthcare/MobileLearning.tsx": [
		92864,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		92864
	],
	"./pages/industries/Healthcare/Simulation": [
		28913,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		28913
	],
	"./pages/industries/Healthcare/Simulation.tsx": [
		28913,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		28913
	],
	"./pages/industries/Healthcare/Wearables": [
		3562,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		3562
	],
	"./pages/industries/Healthcare/Wearables.tsx": [
		3562,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		3562
	],
	"./pages/industries/Industries": [
		86116,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		86116
	],
	"./pages/industries/Industries.tsx": [
		86116,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		86116
	],
	"./pages/industries/Manufacturing": [
		27626,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		27626
	],
	"./pages/industries/Manufacturing.tsx": [
		27626,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		27626
	],
	"./pages/industries/Manufacturing/SupplyChainManagementSolution": [
		63935,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		63935
	],
	"./pages/industries/Manufacturing/SupplyChainManagementSolution.tsx": [
		63935,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		63935
	],
	"./pages/industries/Manufacturing/TransportationManagement": [
		86476,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		86476
	],
	"./pages/industries/Manufacturing/TransportationManagement.tsx": [
		86476,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		86476
	],
	"./pages/industries/Manufacturing/WarehouseManagementSolution": [
		29746,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		29746
	],
	"./pages/industries/Manufacturing/WarehouseManagementSolution.tsx": [
		29746,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		29746
	],
	"./pages/industries/MediaAndEntertainment": [
		67659,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		67659
	],
	"./pages/industries/MediaAndEntertainment.tsx": [
		67659,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		67659
	],
	"./pages/industries/MediaAndEntertainment/DigitalAssestManagementSolutions": [
		44872,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		44872
	],
	"./pages/industries/MediaAndEntertainment/DigitalAssestManagementSolutions.tsx": [
		44872,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		44872
	],
	"./pages/industries/MediaAndEntertainment/EnterpriseContentManagementSolutions": [
		50047,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		50047
	],
	"./pages/industries/MediaAndEntertainment/EnterpriseContentManagementSolutions.tsx": [
		50047,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		50047
	],
	"./pages/industries/MediaAndEntertainment/OTTSoftwareSolutions": [
		47960,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47960
	],
	"./pages/industries/MediaAndEntertainment/OTTSoftwareSolutions.tsx": [
		47960,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47960
	],
	"./pages/industries/RealEstate": [
		17878,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		17878
	],
	"./pages/industries/RealEstate.tsx": [
		17878,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		17878
	],
	"./pages/industries/Retail": [
		25431,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		25431
	],
	"./pages/industries/Retail.tsx": [
		25431,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		25431
	],
	"./pages/industries/Retail/B2BCommerceSolutions": [
		64425,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		64425
	],
	"./pages/industries/Retail/B2BCommerceSolutions.tsx": [
		64425,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		64425
	],
	"./pages/industries/Retail/B2CCommerceSolutions": [
		26638,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		26638
	],
	"./pages/industries/Retail/B2CCommerceSolutions.tsx": [
		26638,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		26638
	],
	"./pages/industries/Retail/DealershipManagementSolutions": [
		65326,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		65326
	],
	"./pages/industries/Retail/DealershipManagementSolutions.tsx": [
		65326,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		65326
	],
	"./pages/industries/Retail/LeadManagementSystem": [
		81752,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		81752
	],
	"./pages/industries/Retail/LeadManagementSystem.tsx": [
		81752,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		81752
	],
	"./pages/industries/Retail/ProductInformationManagement": [
		68012,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		68012
	],
	"./pages/industries/Retail/ProductInformationManagement.tsx": [
		68012,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		68012
	],
	"./pages/industries/Retail/SalesforceAutomationSolutions": [
		61062,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		61062
	],
	"./pages/industries/Retail/SalesforceAutomationSolutions.tsx": [
		61062,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		61062
	],
	"./pages/industries/Retail/Wearables": [
		19810,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		19810
	],
	"./pages/industries/Retail/Wearables.tsx": [
		19810,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		19810
	],
	"./pages/industries/Technology": [
		53432,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		53432
	],
	"./pages/industries/Technology.tsx": [
		53432,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		53432
	],
	"./pages/industries/Transportation": [
		57292,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		57292
	],
	"./pages/industries/Transportation.tsx": [
		57292,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		57292
	],
	"./pages/industries/automotive/AIMachineLearning": [
		51719,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		51719
	],
	"./pages/industries/automotive/AIMachineLearning.tsx": [
		51719,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		51719
	],
	"./pages/industries/automotive/AutonomousADAS": [
		72421,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		72421
	],
	"./pages/industries/automotive/AutonomousADAS.tsx": [
		72421,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		72421
	],
	"./pages/industries/automotive/ConnectedCars": [
		6100,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		6100
	],
	"./pages/industries/automotive/ConnectedCars.tsx": [
		6100,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		6100
	],
	"./pages/industries/automotive/EVChargingSoftware": [
		19813,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		19813
	],
	"./pages/industries/automotive/EVChargingSoftware.tsx": [
		19813,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		19813
	],
	"./pages/industries/automotive/HMI": [
		39046,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		39046
	],
	"./pages/industries/automotive/HMI.tsx": [
		39046,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		39046
	],
	"./pages/industries/automotive/NavigationMapping": [
		16720,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		16720
	],
	"./pages/industries/automotive/NavigationMapping.tsx": [
		16720,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		16720
	],
	"./pages/industries/automotive/Security": [
		74600,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		74600
	],
	"./pages/industries/automotive/Security.tsx": [
		74600,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		74600
	],
	"./pages/industries/automotive/SmartBikes": [
		9753,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		9753
	],
	"./pages/industries/automotive/SmartBikes.tsx": [
		9753,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		9753
	],
	"./pages/industries/automotive/Telematics": [
		87087,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		87087
	],
	"./pages/industries/automotive/Telematics.tsx": [
		87087,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		87087
	],
	"./pages/portfolio/AISolutions": [
		97992,
		9,
		96213,
		97992
	],
	"./pages/portfolio/AISolutions.tsx": [
		97992,
		9,
		96213,
		97992
	],
	"./pages/portfolio/MobileApps": [
		55918,
		9,
		96213,
		55918,
		34398
	],
	"./pages/portfolio/MobileApps.tsx": [
		55918,
		9,
		96213,
		55918,
		34398
	],
	"./pages/portfolio/SmartApplications": [
		42899,
		9,
		96213,
		65280,
		34398
	],
	"./pages/portfolio/SmartApplications.tsx": [
		42899,
		9,
		96213,
		65280,
		34398
	],
	"./pages/portfolio/SocialCommunities": [
		45010,
		9,
		96213,
		45010,
		34398
	],
	"./pages/portfolio/SocialCommunities.tsx": [
		45010,
		9,
		96213,
		45010,
		34398
	],
	"./pages/portfolio/WebPortfolio": [
		6490,
		9,
		96213,
		6490
	],
	"./pages/portfolio/WebPortfolio.tsx": [
		6490,
		9,
		96213,
		6490
	],
	"./pages/services/Services": [
		48996,
		9,
		48996
	],
	"./pages/services/Services.tsx": [
		48996,
		9,
		48996
	],
	"./pages/services/automation/Automation": [
		16107,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16107
	],
	"./pages/services/automation/Automation.tsx": [
		16107,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16107
	],
	"./pages/services/automation/HRAutomation": [
		28921,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		28921
	],
	"./pages/services/automation/HRAutomation.tsx": [
		28921,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		28921
	],
	"./pages/services/automation/IntelligentAutomation": [
		13982,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		13982
	],
	"./pages/services/automation/IntelligentAutomation.tsx": [
		13982,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		13982
	],
	"./pages/services/automation/ProcessAutomation": [
		70062,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		70062
	],
	"./pages/services/automation/ProcessAutomation.tsx": [
		70062,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		70062
	],
	"./pages/services/automation/SalesMarketingAutomation": [
		40731,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		40731
	],
	"./pages/services/automation/SalesMarketingAutomation.tsx": [
		40731,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		40731
	],
	"./pages/services/custom_framework/CustomFramework": [
		73494,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		73494
	],
	"./pages/services/custom_framework/CustomFramework.tsx": [
		73494,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		73494
	],
	"./pages/services/custom_framework/Dotnet": [
		18635,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		18635
	],
	"./pages/services/custom_framework/Dotnet.tsx": [
		18635,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		18635
	],
	"./pages/services/custom_framework/Java": [
		57053,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		57053
	],
	"./pages/services/custom_framework/Java.tsx": [
		57053,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		57053
	],
	"./pages/services/custom_framework/Nodejs": [
		21808,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		21808
	],
	"./pages/services/custom_framework/Nodejs.tsx": [
		21808,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		21808
	],
	"./pages/services/custom_framework/PHP": [
		88257,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88257
	],
	"./pages/services/custom_framework/PHP.tsx": [
		88257,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88257
	],
	"./pages/services/dashboard_development/DashboardDevelopment": [
		42714,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		42714
	],
	"./pages/services/dashboard_development/DashboardDevelopment.tsx": [
		42714,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		42714
	],
	"./pages/services/dashboard_development/DashboardsForManagement": [
		94352,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		94352
	],
	"./pages/services/dashboard_development/DashboardsForManagement.tsx": [
		94352,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		94352
	],
	"./pages/services/dashboard_development/EnterpriseDashboard": [
		40550,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		40550
	],
	"./pages/services/dashboard_development/EnterpriseDashboard.tsx": [
		40550,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		40550
	],
	"./pages/services/dashboard_development/FinanceDashboard": [
		3023,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		3023
	],
	"./pages/services/dashboard_development/FinanceDashboard.tsx": [
		3023,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		3023
	],
	"./pages/services/dashboard_development/HRDashboard": [
		54975,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		54975
	],
	"./pages/services/dashboard_development/HRDashboard.tsx": [
		54975,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		54975
	],
	"./pages/services/dashboard_development/MarketingDashboard": [
		53153,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		53153
	],
	"./pages/services/dashboard_development/MarketingDashboard.tsx": [
		53153,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		53153
	],
	"./pages/services/dashboard_development/OperationalDashboard": [
		47189,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47189
	],
	"./pages/services/dashboard_development/OperationalDashboard.tsx": [
		47189,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47189
	],
	"./pages/services/dashboard_development/ProjectManagementDashboard": [
		56379,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		56379
	],
	"./pages/services/dashboard_development/ProjectManagementDashboard.tsx": [
		56379,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		56379
	],
	"./pages/services/dashboard_development/SalesDashboard": [
		65161,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		65161
	],
	"./pages/services/dashboard_development/SalesDashboard.tsx": [
		65161,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		65161
	],
	"./pages/services/dev_ops/CloudDevOpsServices": [
		96983,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		96983
	],
	"./pages/services/dev_ops/CloudDevOpsServices.tsx": [
		96983,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		96983
	],
	"./pages/services/dev_ops/CloudSupportService": [
		71770,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		71770
	],
	"./pages/services/dev_ops/CloudSupportService.tsx": [
		71770,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		71770
	],
	"./pages/services/dev_ops/CyberSecurity": [
		23490,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		23490
	],
	"./pages/services/dev_ops/CyberSecurity.tsx": [
		23490,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		23490
	],
	"./pages/services/dev_ops/DevOps": [
		27352,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		27352
	],
	"./pages/services/dev_ops/DevOps.tsx": [
		27352,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		27352
	],
	"./pages/services/dev_ops/DevOpsAccessementService": [
		65348,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		65348
	],
	"./pages/services/dev_ops/DevOpsAccessementService.tsx": [
		65348,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		65348
	],
	"./pages/services/dev_ops/DevOpsAutomation": [
		49861,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		49861
	],
	"./pages/services/dev_ops/DevOpsAutomation.tsx": [
		49861,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		49861
	],
	"./pages/services/dev_ops/DevOpsImplementationService": [
		55101,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		55101
	],
	"./pages/services/dev_ops/DevOpsImplementationService.tsx": [
		55101,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		55101
	],
	"./pages/services/dev_ops/DevOpsMonitoring": [
		32358,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		32358
	],
	"./pages/services/dev_ops/DevOpsMonitoring.tsx": [
		32358,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		32358
	],
	"./pages/services/dev_ops/DevSecOps": [
		24447,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		24447
	],
	"./pages/services/dev_ops/DevSecOps.tsx": [
		24447,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		24447
	],
	"./pages/services/dev_ops/SiteReliabilityEngineering": [
		58467,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		58467
	],
	"./pages/services/dev_ops/SiteReliabilityEngineering.tsx": [
		58467,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		58467
	],
	"./pages/services/digital_marketing/ContentMarketing": [
		30449,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30449
	],
	"./pages/services/digital_marketing/ContentMarketing.tsx": [
		30449,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30449
	],
	"./pages/services/digital_marketing/DigitalMarketing": [
		5140,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		5140
	],
	"./pages/services/digital_marketing/DigitalMarketing.tsx": [
		5140,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		5140
	],
	"./pages/services/digital_marketing/ORM": [
		14506,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		14506
	],
	"./pages/services/digital_marketing/ORM.tsx": [
		14506,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		14506
	],
	"./pages/services/digital_marketing/SEO": [
		89961,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		89961
	],
	"./pages/services/digital_marketing/SEO.tsx": [
		89961,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		89961
	],
	"./pages/services/digital_marketing/SMO": [
		83921,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19083,
		83921
	],
	"./pages/services/digital_marketing/SMO.tsx": [
		83921,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19083,
		83921
	],
	"./pages/services/e_commerce/B2BCommerce": [
		47839,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47839
	],
	"./pages/services/e_commerce/B2BCommerce.tsx": [
		47839,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47839
	],
	"./pages/services/e_commerce/B2CCommerce": [
		81210,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		81210
	],
	"./pages/services/e_commerce/B2CCommerce.tsx": [
		81210,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		81210
	],
	"./pages/services/e_commerce/ChatGptIntegration": [
		32075,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		32075
	],
	"./pages/services/e_commerce/ChatGptIntegration.tsx": [
		32075,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		32075
	],
	"./pages/services/e_commerce/Customization": [
		53983,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		53983
	],
	"./pages/services/e_commerce/Customization.tsx": [
		53983,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		53983
	],
	"./pages/services/e_commerce/Omnichannel": [
		82648,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		82648
	],
	"./pages/services/e_commerce/Omnichannel.tsx": [
		82648,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		82648
	],
	"./pages/services/e_commerce/eCommerce": [
		30768,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30768
	],
	"./pages/services/e_commerce/eCommerce.tsx": [
		30768,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30768
	],
	"./pages/services/emerging_tech/AI": [
		24250,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24250
	],
	"./pages/services/emerging_tech/AI.tsx": [
		24250,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24250
	],
	"./pages/services/emerging_tech/BlockChain": [
		7706,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		7706
	],
	"./pages/services/emerging_tech/BlockChain.tsx": [
		7706,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		7706
	],
	"./pages/services/emerging_tech/DataAnalytics": [
		5646,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		65670,
		5646
	],
	"./pages/services/emerging_tech/DataAnalytics.tsx": [
		5646,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		65670,
		5646
	],
	"./pages/services/emerging_tech/EmergingTech": [
		88650,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88650
	],
	"./pages/services/emerging_tech/EmergingTech.tsx": [
		88650,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88650
	],
	"./pages/services/emerging_tech/MachineLearning": [
		27299,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		27299
	],
	"./pages/services/emerging_tech/MachineLearning.tsx": [
		27299,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		27299
	],
	"./pages/services/enterprise_digital_transformation/EnterpriseDigitalTransformation": [
		30955,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30955
	],
	"./pages/services/enterprise_digital_transformation/EnterpriseDigitalTransformation.tsx": [
		30955,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30955
	],
	"./pages/services/enterprise_digital_transformation/EnterpriseSoftwareSolution": [
		41564,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		41564
	],
	"./pages/services/enterprise_digital_transformation/EnterpriseSoftwareSolution.tsx": [
		41564,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		41564
	],
	"./pages/services/enterprise_digital_transformation/MetaverseDevelopment": [
		5662,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		5662
	],
	"./pages/services/enterprise_digital_transformation/MetaverseDevelopment.tsx": [
		5662,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		5662
	],
	"./pages/services/enterprise_digital_transformation/ProcessHarmonization": [
		81585,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		81585
	],
	"./pages/services/enterprise_digital_transformation/ProcessHarmonization.tsx": [
		81585,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		81585
	],
	"./pages/services/enterprise_digital_transformation/SalesforceSolution": [
		44975,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		44975
	],
	"./pages/services/enterprise_digital_transformation/SalesforceSolution.tsx": [
		44975,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		44975
	],
	"./pages/services/enterprise_digital_transformation/WorkFlowSolution": [
		23645,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		23645
	],
	"./pages/services/enterprise_digital_transformation/WorkFlowSolution.tsx": [
		23645,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		23645
	],
	"./pages/services/iot/ConnectedTech": [
		99018,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		99018
	],
	"./pages/services/iot/ConnectedTech.tsx": [
		99018,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		99018
	],
	"./pages/services/iot/FacilityMonitoring": [
		79986,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		79986
	],
	"./pages/services/iot/FacilityMonitoring.tsx": [
		79986,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		79986
	],
	"./pages/services/iot/IndustrialIoT": [
		31068,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		31068
	],
	"./pages/services/iot/IndustrialIoT.tsx": [
		31068,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		31068
	],
	"./pages/services/iot/IoT": [
		3963,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		3963
	],
	"./pages/services/iot/IoT.tsx": [
		3963,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		3963
	],
	"./pages/services/iot/IoTIntegration": [
		617,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		617
	],
	"./pages/services/iot/IoTIntegration.tsx": [
		617,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		617
	],
	"./pages/services/mobile_apps/Hybrid": [
		29862,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		29862
	],
	"./pages/services/mobile_apps/Hybrid.tsx": [
		29862,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		29862
	],
	"./pages/services/mobile_apps/MobileAndroid": [
		85589,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		85589
	],
	"./pages/services/mobile_apps/MobileAndroid.tsx": [
		85589,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		85589
	],
	"./pages/services/mobile_apps/MobileApps": [
		90614,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90614
	],
	"./pages/services/mobile_apps/MobileApps.tsx": [
		90614,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90614
	],
	"./pages/services/mobile_apps/MobileIos": [
		4999,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		4999
	],
	"./pages/services/mobile_apps/MobileIos.tsx": [
		4999,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		4999
	],
	"./pages/services/mobile_apps/PWAS": [
		69363,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		69363
	],
	"./pages/services/mobile_apps/PWAS.tsx": [
		69363,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		69363
	],
	"./pages/services/product_engineering/ProductApplicationCatalogue": [
		51594,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		51594
	],
	"./pages/services/product_engineering/ProductApplicationCatalogue.tsx": [
		51594,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		51594
	],
	"./pages/services/product_engineering/ProductDesign": [
		92261,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		92261
	],
	"./pages/services/product_engineering/ProductDesign.tsx": [
		92261,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		92261
	],
	"./pages/services/product_engineering/ProductDevelopment": [
		53408,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		53408
	],
	"./pages/services/product_engineering/ProductDevelopment.tsx": [
		53408,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		53408
	],
	"./pages/services/product_engineering/ProductEngineering": [
		54526,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		54526
	],
	"./pages/services/product_engineering/ProductEngineering.tsx": [
		54526,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		54526
	],
	"./pages/services/product_engineering/SolutionArchitecture": [
		51388,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		51388
	],
	"./pages/services/product_engineering/SolutionArchitecture.tsx": [
		51388,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		51388
	],
	"./pages/services/product_engineering/TechSupport": [
		70235,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		70235
	],
	"./pages/services/product_engineering/TechSupport.tsx": [
		70235,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		70235
	],
	"./pages/services/prototyping_uI_ux/HighFidelity": [
		72013,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		72013
	],
	"./pages/services/prototyping_uI_ux/HighFidelity.tsx": [
		72013,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		72013
	],
	"./pages/services/prototyping_uI_ux/LowFidelity": [
		15779,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		15779
	],
	"./pages/services/prototyping_uI_ux/LowFidelity.tsx": [
		15779,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		15779
	],
	"./pages/services/prototyping_uI_ux/MVPs": [
		89769,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		89769
	],
	"./pages/services/prototyping_uI_ux/MVPs.tsx": [
		89769,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		89769
	],
	"./pages/services/prototyping_uI_ux/ProtoTypingUiUx": [
		34717,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		34717
	],
	"./pages/services/prototyping_uI_ux/ProtoTypingUiUx.tsx": [
		34717,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		34717
	],
	"./pages/services/prototyping_uI_ux/RapidPrototype": [
		42023,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42023
	],
	"./pages/services/prototyping_uI_ux/RapidPrototype.tsx": [
		42023,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42023
	],
	"./pages/services/prototyping_uI_ux/UiUxDesign": [
		98728,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		98728
	],
	"./pages/services/prototyping_uI_ux/UiUxDesign.tsx": [
		98728,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		98728
	],
	"./pages/services/testing_qa/AutomationTesting": [
		47215,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47215
	],
	"./pages/services/testing_qa/AutomationTesting.tsx": [
		47215,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47215
	],
	"./pages/services/testing_qa/FunctionalTesting": [
		57005,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		57005
	],
	"./pages/services/testing_qa/FunctionalTesting.tsx": [
		57005,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		57005
	],
	"./pages/services/testing_qa/ManualTesting": [
		62482,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		62482
	],
	"./pages/services/testing_qa/ManualTesting.tsx": [
		62482,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		62482
	],
	"./pages/services/testing_qa/TestingQA": [
		48986,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		48986
	],
	"./pages/services/testing_qa/TestingQA.tsx": [
		48986,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		48986
	],
	"./pages/services/testing_qa/VAPT": [
		18817,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		18817
	],
	"./pages/services/testing_qa/VAPT.tsx": [
		18817,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		18817
	],
	"./pages/staff_augmentation/StaffAugmentation": [
		29849,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		17695,
		29849
	],
	"./pages/staff_augmentation/StaffAugmentation.tsx": [
		29849,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		17695,
		29849
	],
	"./pages/staff_augmentation/backend/Backend": [
		6414,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		6414
	],
	"./pages/staff_augmentation/backend/Backend.tsx": [
		6414,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		6414
	],
	"./pages/staff_augmentation/backend/DotNet": [
		42146,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42146
	],
	"./pages/staff_augmentation/backend/DotNet.tsx": [
		42146,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42146
	],
	"./pages/staff_augmentation/backend/GraphQL": [
		33517,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		33517
	],
	"./pages/staff_augmentation/backend/GraphQL.tsx": [
		33517,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		33517
	],
	"./pages/staff_augmentation/backend/Java": [
		33640,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		33640
	],
	"./pages/staff_augmentation/backend/Java.tsx": [
		33640,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		33640
	],
	"./pages/staff_augmentation/backend/Php": [
		75750,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		75750
	],
	"./pages/staff_augmentation/backend/Php.tsx": [
		75750,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		75750
	],
	"./pages/staff_augmentation/backend/Python": [
		22862,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		22862
	],
	"./pages/staff_augmentation/backend/Python.tsx": [
		22862,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		22862
	],
	"./pages/staff_augmentation/cms/CMS": [
		77102,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		77102
	],
	"./pages/staff_augmentation/cms/CMS.tsx": [
		77102,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		77102
	],
	"./pages/staff_augmentation/cms/Drupal": [
		38099,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		38099
	],
	"./pages/staff_augmentation/cms/Drupal.tsx": [
		38099,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		38099
	],
	"./pages/staff_augmentation/cms/Kentico": [
		36148,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		36148
	],
	"./pages/staff_augmentation/cms/Kentico.tsx": [
		36148,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		36148
	],
	"./pages/staff_augmentation/cms/Magento": [
		97398,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		97398
	],
	"./pages/staff_augmentation/cms/Magento.tsx": [
		97398,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		97398
	],
	"./pages/staff_augmentation/cms/Sitecore": [
		90001,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		62497,
		90001
	],
	"./pages/staff_augmentation/cms/Sitecore.tsx": [
		90001,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		62497,
		90001
	],
	"./pages/staff_augmentation/cms/WordPress": [
		47372,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		93072,
		47372
	],
	"./pages/staff_augmentation/cms/WordPress.tsx": [
		47372,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		93072,
		47372
	],
	"./pages/staff_augmentation/devops/AWS": [
		82954,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		82954
	],
	"./pages/staff_augmentation/devops/AWS.tsx": [
		82954,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		82954
	],
	"./pages/staff_augmentation/devops/Azure": [
		46352,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		46352
	],
	"./pages/staff_augmentation/devops/Azure.tsx": [
		46352,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		46352
	],
	"./pages/staff_augmentation/devops/Cybersecurity": [
		53232,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		53232
	],
	"./pages/staff_augmentation/devops/Cybersecurity.tsx": [
		53232,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		53232
	],
	"./pages/staff_augmentation/devops/DevOps": [
		27350,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		27350
	],
	"./pages/staff_augmentation/devops/DevOps.tsx": [
		27350,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		27350
	],
	"./pages/staff_augmentation/devops/GCP": [
		95707,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		95707
	],
	"./pages/staff_augmentation/devops/GCP.tsx": [
		95707,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		95707
	],
	"./pages/staff_augmentation/ecommerce/Drupal": [
		64694,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		64694
	],
	"./pages/staff_augmentation/ecommerce/Drupal.tsx": [
		64694,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		64694
	],
	"./pages/staff_augmentation/ecommerce/Magento": [
		47137,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		47137
	],
	"./pages/staff_augmentation/ecommerce/Magento.tsx": [
		47137,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		47137
	],
	"./pages/staff_augmentation/ecommerce/Shopify": [
		8552,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		8552
	],
	"./pages/staff_augmentation/ecommerce/Shopify.tsx": [
		8552,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		8552
	],
	"./pages/staff_augmentation/ecommerce/WooCommerce": [
		26546,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		43482,
		26546
	],
	"./pages/staff_augmentation/ecommerce/WooCommerce.tsx": [
		26546,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		43482,
		26546
	],
	"./pages/staff_augmentation/ecommerce/eCommerce": [
		82470,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		79698,
		82470
	],
	"./pages/staff_augmentation/ecommerce/eCommerce.tsx": [
		82470,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		79698,
		82470
	],
	"./pages/staff_augmentation/enterprise/BigData": [
		21457,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		21457
	],
	"./pages/staff_augmentation/enterprise/BigData.tsx": [
		21457,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		21457
	],
	"./pages/staff_augmentation/enterprise/DevOps": [
		36052,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		36052
	],
	"./pages/staff_augmentation/enterprise/DevOps.tsx": [
		36052,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		36052
	],
	"./pages/staff_augmentation/enterprise/Enterprise": [
		89902,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		89902
	],
	"./pages/staff_augmentation/enterprise/Enterprise.tsx": [
		89902,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		89902
	],
	"./pages/staff_augmentation/enterprise/Salesforce": [
		73050,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		73050
	],
	"./pages/staff_augmentation/enterprise/Salesforce.tsx": [
		73050,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		73050
	],
	"./pages/staff_augmentation/enterprise/SharePoint": [
		73706,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		73706
	],
	"./pages/staff_augmentation/enterprise/SharePoint.tsx": [
		73706,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		73706
	],
	"./pages/staff_augmentation/frontend/Angular": [
		67944,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		67944
	],
	"./pages/staff_augmentation/frontend/Angular.tsx": [
		67944,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		67944
	],
	"./pages/staff_augmentation/frontend/Frontend": [
		37732,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		37732
	],
	"./pages/staff_augmentation/frontend/Frontend.tsx": [
		37732,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		37732
	],
	"./pages/staff_augmentation/frontend/HtmlAndCss": [
		39775,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		39775
	],
	"./pages/staff_augmentation/frontend/HtmlAndCss.tsx": [
		39775,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		39775
	],
	"./pages/staff_augmentation/frontend/React": [
		65071,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		65071
	],
	"./pages/staff_augmentation/frontend/React.tsx": [
		65071,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		65071
	],
	"./pages/staff_augmentation/frontend/Vuejs": [
		64899,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		43367,
		64899
	],
	"./pages/staff_augmentation/frontend/Vuejs.tsx": [
		64899,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		43367,
		64899
	],
	"./pages/staff_augmentation/js/AngularJs": [
		16152,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		16152
	],
	"./pages/staff_augmentation/js/AngularJs.tsx": [
		16152,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		16152
	],
	"./pages/staff_augmentation/js/JS": [
		10190,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		10190
	],
	"./pages/staff_augmentation/js/JS.tsx": [
		10190,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		10190
	],
	"./pages/staff_augmentation/js/NodeJs": [
		90066,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		90066
	],
	"./pages/staff_augmentation/js/NodeJs.tsx": [
		90066,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		90066
	],
	"./pages/staff_augmentation/js/ReactJs": [
		42811,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42811
	],
	"./pages/staff_augmentation/js/ReactJs.tsx": [
		42811,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42811
	],
	"./pages/staff_augmentation/js/VueJs": [
		70302,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		41400,
		70302
	],
	"./pages/staff_augmentation/js/VueJs.tsx": [
		70302,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		41400,
		70302
	],
	"./pages/staff_augmentation/mobile/Android": [
		42278,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42278
	],
	"./pages/staff_augmentation/mobile/Android.tsx": [
		42278,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		42278
	],
	"./pages/staff_augmentation/mobile/Flutter": [
		19174,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		19174
	],
	"./pages/staff_augmentation/mobile/Flutter.tsx": [
		19174,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		19174
	],
	"./pages/staff_augmentation/mobile/IoS": [
		23427,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		23427
	],
	"./pages/staff_augmentation/mobile/IoS.tsx": [
		23427,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		23427
	],
	"./pages/staff_augmentation/mobile/Mobile": [
		94148,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		94148
	],
	"./pages/staff_augmentation/mobile/Mobile.tsx": [
		94148,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		94148
	],
	"./pages/staff_augmentation/mobile/ReactNative": [
		71392,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		71392
	],
	"./pages/staff_augmentation/mobile/ReactNative.tsx": [
		71392,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		71392
	],
	"./pages/staff_augmentation/ops/AgileCoaches": [
		83698,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		32840,
		83698
	],
	"./pages/staff_augmentation/ops/AgileCoaches.tsx": [
		83698,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		32840,
		83698
	],
	"./pages/staff_augmentation/ops/HRProfessionals": [
		72160,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		76172,
		72160
	],
	"./pages/staff_augmentation/ops/HRProfessionals.tsx": [
		72160,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		76172,
		72160
	],
	"./pages/staff_augmentation/ops/Ops": [
		48286,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		7202,
		48286
	],
	"./pages/staff_augmentation/ops/Ops.tsx": [
		48286,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		7202,
		48286
	],
	"./pages/staff_augmentation/ops/ProjectManagers": [
		79409,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		79409
	],
	"./pages/staff_augmentation/ops/ProjectManagers.tsx": [
		79409,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		79409
	],
	"./pages/staff_augmentation/ops/ScrumMasters": [
		59075,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		59075
	],
	"./pages/staff_augmentation/ops/ScrumMasters.tsx": [
		59075,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		59075
	],
	"./pages/staff_augmentation/qa/Automation": [
		52011,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		52011
	],
	"./pages/staff_augmentation/qa/Automation.tsx": [
		52011,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		52011
	],
	"./pages/staff_augmentation/qa/Manual": [
		83835,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		17776,
		83835
	],
	"./pages/staff_augmentation/qa/Manual.tsx": [
		83835,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		17776,
		83835
	],
	"./pages/staff_augmentation/qa/Qa": [
		61848,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		61848
	],
	"./pages/staff_augmentation/qa/Qa.tsx": [
		61848,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		61848
	],
	"./pages/staff_augmentation/web/Drupal": [
		30288,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		30288
	],
	"./pages/staff_augmentation/web/Drupal.tsx": [
		30288,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		30288
	],
	"./pages/staff_augmentation/web/Laravel": [
		73995,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		73995
	],
	"./pages/staff_augmentation/web/Laravel.tsx": [
		73995,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		73995
	],
	"./pages/staff_augmentation/web/PHP": [
		55956,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		55956
	],
	"./pages/staff_augmentation/web/PHP.tsx": [
		55956,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		55956
	],
	"./pages/staff_augmentation/web/Python": [
		74888,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		74888
	],
	"./pages/staff_augmentation/web/Python.tsx": [
		74888,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		74888
	],
	"./pages/staff_augmentation/web/Web": [
		794,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		794
	],
	"./pages/staff_augmentation/web/Web.tsx": [
		794,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		794
	],
	"./pages/staff_augmentation/web/WordPress": [
		33889,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		24875,
		33889
	],
	"./pages/staff_augmentation/web/WordPress.tsx": [
		33889,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		52700,
		24875,
		33889
	],
	"./pages/success_stories/SuccessStories": [
		52237,
		9,
		73677,
		57720,
		52237,
		12813
	],
	"./pages/success_stories/SuccessStories.tsx": [
		52237,
		9,
		73677,
		57720,
		52237,
		12813
	],
	"./pages/technologies/Technologies": [
		42584,
		9,
		42584
	],
	"./pages/technologies/Technologies.tsx": [
		42584,
		9,
		42584
	],
	"./pages/technologies/cloud_devops_devse_ops/AWSCloudSolution": [
		69652,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		69652
	],
	"./pages/technologies/cloud_devops_devse_ops/AWSCloudSolution.tsx": [
		69652,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		69652
	],
	"./pages/technologies/cloud_devops_devse_ops/AWSManagedServices": [
		77417,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		77417
	],
	"./pages/technologies/cloud_devops_devse_ops/AWSManagedServices.tsx": [
		77417,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		77417
	],
	"./pages/technologies/cloud_devops_devse_ops/AzureCloudSolution": [
		14214,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		14214
	],
	"./pages/technologies/cloud_devops_devse_ops/AzureCloudSolution.tsx": [
		14214,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		14214
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudArchitecture": [
		26293,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		26293
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudArchitecture.tsx": [
		26293,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		26293
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudDevOpsDevSecOps": [
		1139,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		1139
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudDevOpsDevSecOps.tsx": [
		1139,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		1139
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudHosting": [
		95892,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		95892
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudHosting.tsx": [
		95892,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		95892
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudMigration": [
		93906,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		93906
	],
	"./pages/technologies/cloud_devops_devse_ops/CloudMigration.tsx": [
		93906,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		93906
	],
	"./pages/technologies/cloud_devops_devse_ops/CyberSecurity": [
		8858,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		8858
	],
	"./pages/technologies/cloud_devops_devse_ops/CyberSecurity.tsx": [
		8858,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		8858
	],
	"./pages/technologies/cloud_devops_devse_ops/DevOpsEngineering": [
		33591,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		33591
	],
	"./pages/technologies/cloud_devops_devse_ops/DevOpsEngineering.tsx": [
		33591,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		33591
	],
	"./pages/technologies/cloud_devops_devse_ops/GCPSolution": [
		23908,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		23908
	],
	"./pages/technologies/cloud_devops_devse_ops/GCPSolution.tsx": [
		23908,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		23908
	],
	"./pages/technologies/cloud_devops_devse_ops/VAPT": [
		18964,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		18964
	],
	"./pages/technologies/cloud_devops_devse_ops/VAPT.tsx": [
		18964,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		18964
	],
	"./pages/technologies/content_management_system/BigCommerce": [
		24487,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24487
	],
	"./pages/technologies/content_management_system/BigCommerce.tsx": [
		24487,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24487
	],
	"./pages/technologies/content_management_system/CSCart": [
		32938,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		32938
	],
	"./pages/technologies/content_management_system/CSCart.tsx": [
		32938,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		32938
	],
	"./pages/technologies/content_management_system/ContentManagementSystem": [
		43201,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		43201
	],
	"./pages/technologies/content_management_system/ContentManagementSystem.tsx": [
		43201,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		43201
	],
	"./pages/technologies/content_management_system/Drupal": [
		44464,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		44464
	],
	"./pages/technologies/content_management_system/Drupal.tsx": [
		44464,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		44464
	],
	"./pages/technologies/content_management_system/HeadlessDevelopment": [
		24184,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24184
	],
	"./pages/technologies/content_management_system/HeadlessDevelopment.tsx": [
		24184,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24184
	],
	"./pages/technologies/content_management_system/Magento": [
		199,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		199
	],
	"./pages/technologies/content_management_system/Magento.tsx": [
		199,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		199
	],
	"./pages/technologies/content_management_system/OpenCart": [
		76316,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		76316
	],
	"./pages/technologies/content_management_system/OpenCart.tsx": [
		76316,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		76316
	],
	"./pages/technologies/content_management_system/Prestashop": [
		34613,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		34613
	],
	"./pages/technologies/content_management_system/Prestashop.tsx": [
		34613,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		34613
	],
	"./pages/technologies/content_management_system/Shopify": [
		43142,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		43142
	],
	"./pages/technologies/content_management_system/Shopify.tsx": [
		43142,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		43142
	],
	"./pages/technologies/content_management_system/WooCommerce": [
		85400,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		85400
	],
	"./pages/technologies/content_management_system/WooCommerce.tsx": [
		85400,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		85400
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessDrupal": [
		24953,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24953
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessDrupal.tsx": [
		24953,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		24953
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessMagento": [
		23056,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		23056
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessMagento.tsx": [
		23056,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		23056
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessOpenCart": [
		16237,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16237
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessOpenCart.tsx": [
		16237,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16237
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessPrestashop": [
		296,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		296
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessPrestashop.tsx": [
		296,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		296
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessShopify": [
		94829,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		94829
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessShopify.tsx": [
		94829,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		94829
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessWooCommerce": [
		36619,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		36619
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessWooCommerce.tsx": [
		36619,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		36619
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessWordPress": [
		99418,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		99418
	],
	"./pages/technologies/content_management_system/headless_development/HeadlessWordPress.tsx": [
		99418,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		99418
	],
	"./pages/technologies/custom_application_development/CRM": [
		60739,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		60739
	],
	"./pages/technologies/custom_application_development/CRM.tsx": [
		60739,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		60739
	],
	"./pages/technologies/custom_application_development/CustomApplicationDevelopment": [
		38231,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		38231
	],
	"./pages/technologies/custom_application_development/CustomApplicationDevelopment.tsx": [
		38231,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		38231
	],
	"./pages/technologies/custom_application_development/DigitalSalesSolution": [
		72494,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		72494
	],
	"./pages/technologies/custom_application_development/DigitalSalesSolution.tsx": [
		72494,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		72494
	],
	"./pages/technologies/custom_application_development/ERP": [
		40632,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		40632
	],
	"./pages/technologies/custom_application_development/ERP.tsx": [
		40632,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		40632
	],
	"./pages/technologies/custom_application_development/HRMS": [
		65441,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		65441
	],
	"./pages/technologies/custom_application_development/HRMS.tsx": [
		65441,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		65441
	],
	"./pages/technologies/custom_application_development/HubspotCRMCustomization": [
		79457,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		79457
	],
	"./pages/technologies/custom_application_development/HubspotCRMCustomization.tsx": [
		79457,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		79457
	],
	"./pages/technologies/custom_application_development/LMS": [
		14743,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		14743
	],
	"./pages/technologies/custom_application_development/LMS.tsx": [
		14743,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		14743
	],
	"./pages/technologies/custom_application_development/ProcessHarmonizationSolution": [
		95972,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		95972
	],
	"./pages/technologies/custom_application_development/ProcessHarmonizationSolution.tsx": [
		95972,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		95972
	],
	"./pages/technologies/custom_application_development/SFAs": [
		16800,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		16800
	],
	"./pages/technologies/custom_application_development/SFAs.tsx": [
		16800,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		16800
	],
	"./pages/technologies/custom_application_development/WorkflowManagementSolution": [
		91128,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		91128
	],
	"./pages/technologies/custom_application_development/WorkflowManagementSolution.tsx": [
		91128,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		91128
	],
	"./pages/technologies/emerging_technologies/ArtificalIntelligence": [
		91126,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		91126
	],
	"./pages/technologies/emerging_technologies/ArtificalIntelligence.tsx": [
		91126,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		91126
	],
	"./pages/technologies/emerging_technologies/BigData": [
		52404,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		52404
	],
	"./pages/technologies/emerging_technologies/BigData.tsx": [
		52404,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		52404
	],
	"./pages/technologies/emerging_technologies/ChatGpt": [
		10623,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		89505,
		10623
	],
	"./pages/technologies/emerging_technologies/ChatGpt.tsx": [
		10623,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		89505,
		10623
	],
	"./pages/technologies/emerging_technologies/EmergingTechnologies": [
		88460,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88460
	],
	"./pages/technologies/emerging_technologies/EmergingTechnologies.tsx": [
		88460,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88460
	],
	"./pages/technologies/emerging_technologies/IOT": [
		88958,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88958
	],
	"./pages/technologies/emerging_technologies/IOT.tsx": [
		88958,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		88958
	],
	"./pages/technologies/emerging_technologies/MachineLearning": [
		59447,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		59447
	],
	"./pages/technologies/emerging_technologies/MachineLearning.tsx": [
		59447,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		59447
	],
	"./pages/technologies/emerging_technologies/MachineLearningOperations": [
		75665,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		75665
	],
	"./pages/technologies/emerging_technologies/MachineLearningOperations.tsx": [
		75665,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		75665
	],
	"./pages/technologies/emerging_technologies/NaturalLanguageProcessing": [
		49318,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49318
	],
	"./pages/technologies/emerging_technologies/NaturalLanguageProcessing.tsx": [
		49318,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49318
	],
	"./pages/technologies/emerging_technologies/Rpa": [
		55365,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		55365
	],
	"./pages/technologies/emerging_technologies/Rpa.tsx": [
		55365,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		55365
	],
	"./pages/technologies/emerging_technologies/block_chain/BlockChain": [
		84410,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		84410
	],
	"./pages/technologies/emerging_technologies/block_chain/BlockChain.tsx": [
		84410,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		84410
	],
	"./pages/technologies/emerging_technologies/block_chain/CryptoCurrency": [
		12606,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		12606
	],
	"./pages/technologies/emerging_technologies/block_chain/CryptoCurrency.tsx": [
		12606,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		12606
	],
	"./pages/technologies/emerging_technologies/block_chain/DAppDevelopment": [
		49418,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49418
	],
	"./pages/technologies/emerging_technologies/block_chain/DAppDevelopment.tsx": [
		49418,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49418
	],
	"./pages/technologies/emerging_technologies/block_chain/IcoSolutions": [
		26473,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		26473
	],
	"./pages/technologies/emerging_technologies/block_chain/IcoSolutions.tsx": [
		26473,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		26473
	],
	"./pages/technologies/emerging_technologies/block_chain/IeoSolutions": [
		49771,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49771
	],
	"./pages/technologies/emerging_technologies/block_chain/IeoSolutions.tsx": [
		49771,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49771
	],
	"./pages/technologies/emerging_technologies/block_chain/StoSolutions": [
		90648,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		90648
	],
	"./pages/technologies/emerging_technologies/block_chain/StoSolutions.tsx": [
		90648,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		90648
	],
	"./pages/technologies/enterprise_application_development/ApplicationDevelopmentMaintenance": [
		90913,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		90913
	],
	"./pages/technologies/enterprise_application_development/ApplicationDevelopmentMaintenance.tsx": [
		90913,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		90913
	],
	"./pages/technologies/enterprise_application_development/Dashboard": [
		35515,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		35515
	],
	"./pages/technologies/enterprise_application_development/Dashboard.tsx": [
		35515,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		35515
	],
	"./pages/technologies/enterprise_application_development/EnterpriseApplicationDevelopment": [
		23179,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		23179
	],
	"./pages/technologies/enterprise_application_development/EnterpriseApplicationDevelopment.tsx": [
		23179,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		23179
	],
	"./pages/technologies/enterprise_application_development/EnterpriseSoftwareSolutions": [
		65549,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		65549
	],
	"./pages/technologies/enterprise_application_development/EnterpriseSoftwareSolutions.tsx": [
		65549,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		65549
	],
	"./pages/technologies/enterprise_application_development/HeadlessDevelopment": [
		98199,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		98199
	],
	"./pages/technologies/enterprise_application_development/HeadlessDevelopment.tsx": [
		98199,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		98199
	],
	"./pages/technologies/enterprise_application_development/ProcessHarmonization": [
		89869,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		89869
	],
	"./pages/technologies/enterprise_application_development/ProcessHarmonization.tsx": [
		89869,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		89869
	],
	"./pages/technologies/enterprise_application_development/SalesforceSolutions": [
		82496,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		82496
	],
	"./pages/technologies/enterprise_application_development/SalesforceSolutions.tsx": [
		82496,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		82496
	],
	"./pages/technologies/enterprise_application_development/SharePointDevelopment": [
		77215,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		77215
	],
	"./pages/technologies/enterprise_application_development/SharePointDevelopment.tsx": [
		77215,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		77215
	],
	"./pages/technologies/enterprise_application_development/SoftwareProductDevelopment": [
		19592,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19592
	],
	"./pages/technologies/enterprise_application_development/SoftwareProductDevelopment.tsx": [
		19592,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19592
	],
	"./pages/technologies/enterprise_application_development/TableauDashboards": [
		31254,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		31254
	],
	"./pages/technologies/enterprise_application_development/TableauDashboards.tsx": [
		31254,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		31254
	],
	"./pages/technologies/enterprise_application_development/WorkflowSolutions": [
		57286,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		57286
	],
	"./pages/technologies/enterprise_application_development/WorkflowSolutions.tsx": [
		57286,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		57286
	],
	"./pages/technologies/enterprise_application_development/dashboard/DashboardsForManagement": [
		27303,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		6787,
		27303
	],
	"./pages/technologies/enterprise_application_development/dashboard/DashboardsForManagement.tsx": [
		27303,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		6787,
		27303
	],
	"./pages/technologies/enterprise_application_development/dashboard/EnterpriseDashboard": [
		34497,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		34497
	],
	"./pages/technologies/enterprise_application_development/dashboard/EnterpriseDashboard.tsx": [
		34497,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		34497
	],
	"./pages/technologies/enterprise_application_development/dashboard/FinanceDashboard": [
		33006,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		33006
	],
	"./pages/technologies/enterprise_application_development/dashboard/FinanceDashboard.tsx": [
		33006,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		33006
	],
	"./pages/technologies/enterprise_application_development/dashboard/HRDashboard": [
		37632,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		37632
	],
	"./pages/technologies/enterprise_application_development/dashboard/HRDashboard.tsx": [
		37632,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		37632
	],
	"./pages/technologies/enterprise_application_development/dashboard/MarketingDashboard": [
		60048,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		60048
	],
	"./pages/technologies/enterprise_application_development/dashboard/MarketingDashboard.tsx": [
		60048,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		60048
	],
	"./pages/technologies/enterprise_application_development/dashboard/OperationalDashboard": [
		49172,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49172
	],
	"./pages/technologies/enterprise_application_development/dashboard/OperationalDashboard.tsx": [
		49172,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49172
	],
	"./pages/technologies/enterprise_application_development/dashboard/ProjectManagementDashboard": [
		64710,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		64710
	],
	"./pages/technologies/enterprise_application_development/dashboard/ProjectManagementDashboard.tsx": [
		64710,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		64710
	],
	"./pages/technologies/enterprise_application_development/dashboard/SalesDashboard": [
		85192,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		85192
	],
	"./pages/technologies/enterprise_application_development/dashboard/SalesDashboard.tsx": [
		85192,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		85192
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceImplementation": [
		80223,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		20459,
		80223
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceImplementation.tsx": [
		80223,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		20459,
		80223
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceIntegration": [
		35763,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		35763
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceIntegration.tsx": [
		35763,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		35763
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceManagedServices": [
		68442,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		68442
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceManagedServices.tsx": [
		68442,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		68442
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceSalesCloud": [
		18850,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		18850
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceSalesCloud.tsx": [
		18850,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		18850
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceServiceCloud": [
		66757,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		66757
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/SalesforceServiceCloud.tsx": [
		66757,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		66757
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2BCommerceSolution": [
		76148,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		76148
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2BCommerceSolution.tsx": [
		76148,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		76148
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2CCommerceSolution": [
		39753,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		39753
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/B2CCommerceSolution.tsx": [
		39753,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		39753
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/DealershipManagementSolutions": [
		15590,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		15590
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/DealershipManagementSolutions.tsx": [
		15590,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		15590
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/LeadManagementSystem": [
		54288,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		54288
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/LeadManagementSystem.tsx": [
		54288,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		54288
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/ProductInformationManagement": [
		79316,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		79316
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/ProductInformationManagement.tsx": [
		79316,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		79316
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/SalesforceAutomation": [
		92496,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		92496
	],
	"./pages/technologies/enterprise_application_development/salesforce_solutions/salesforce_automation/SalesforceAutomation.tsx": [
		92496,
		9,
		96213,
		71378,
		34462,
		55262,
		85287,
		92496
	],
	"./pages/technologies/microsoft_technologies/Azure": [
		73083,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		73083
	],
	"./pages/technologies/microsoft_technologies/Azure.tsx": [
		73083,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		73083
	],
	"./pages/technologies/microsoft_technologies/Copilot": [
		71750,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		71750
	],
	"./pages/technologies/microsoft_technologies/Copilot.tsx": [
		71750,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		71750
	],
	"./pages/technologies/microsoft_technologies/DotNet": [
		59070,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		59070
	],
	"./pages/technologies/microsoft_technologies/DotNet.tsx": [
		59070,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		59070
	],
	"./pages/technologies/microsoft_technologies/Dynamics365": [
		45040,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		45040
	],
	"./pages/technologies/microsoft_technologies/Dynamics365.tsx": [
		45040,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		45040
	],
	"./pages/technologies/microsoft_technologies/MicrosoftTechnologies": [
		90408,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90408
	],
	"./pages/technologies/microsoft_technologies/MicrosoftTechnologies.tsx": [
		90408,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90408
	],
	"./pages/technologies/microsoft_technologies/PowerApps": [
		90049,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90049
	],
	"./pages/technologies/microsoft_technologies/PowerApps.tsx": [
		90049,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90049
	],
	"./pages/technologies/microsoft_technologies/PowerPlatform": [
		16396,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16396
	],
	"./pages/technologies/microsoft_technologies/PowerPlatform.tsx": [
		16396,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16396
	],
	"./pages/technologies/microsoft_technologies/SharePoint": [
		83517,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		83517
	],
	"./pages/technologies/microsoft_technologies/SharePoint.tsx": [
		83517,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		83517
	],
	"./pages/technologies/mobile_application_development/Android": [
		71301,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		73097,
		71301
	],
	"./pages/technologies/mobile_application_development/Android.tsx": [
		71301,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		73097,
		71301
	],
	"./pages/technologies/mobile_application_development/CrossPlatformApplications": [
		68504,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90606,
		68504
	],
	"./pages/technologies/mobile_application_development/CrossPlatformApplications.tsx": [
		68504,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		90606,
		68504
	],
	"./pages/technologies/mobile_application_development/HybridApp/FlutterApp": [
		4095,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		56577,
		4095
	],
	"./pages/technologies/mobile_application_development/HybridApp/FlutterApp.tsx": [
		4095,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		56577,
		4095
	],
	"./pages/technologies/mobile_application_development/HybridApp/HybridApp": [
		70545,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		70545
	],
	"./pages/technologies/mobile_application_development/HybridApp/HybridApp.tsx": [
		70545,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		70545
	],
	"./pages/technologies/mobile_application_development/HybridApp/IonicApp": [
		33683,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		33683
	],
	"./pages/technologies/mobile_application_development/HybridApp/IonicApp.tsx": [
		33683,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		33683
	],
	"./pages/technologies/mobile_application_development/HybridApp/NativeScriptApp": [
		67143,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		67143
	],
	"./pages/technologies/mobile_application_development/HybridApp/NativeScriptApp.tsx": [
		67143,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		67143
	],
	"./pages/technologies/mobile_application_development/HybridApp/PhoneGapApps": [
		54212,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		54212
	],
	"./pages/technologies/mobile_application_development/HybridApp/PhoneGapApps.tsx": [
		54212,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		54212
	],
	"./pages/technologies/mobile_application_development/HybridApp/ReactNativeApp": [
		4197,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		4197
	],
	"./pages/technologies/mobile_application_development/HybridApp/ReactNativeApp.tsx": [
		4197,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		4197
	],
	"./pages/technologies/mobile_application_development/HybridApp/SenchaApps": [
		38916,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		38916
	],
	"./pages/technologies/mobile_application_development/HybridApp/SenchaApps.tsx": [
		38916,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		38916
	],
	"./pages/technologies/mobile_application_development/HybridApp/TizenApps": [
		75802,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		75802
	],
	"./pages/technologies/mobile_application_development/HybridApp/TizenApps.tsx": [
		75802,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		75802
	],
	"./pages/technologies/mobile_application_development/HybridApp/XamarinApp": [
		96227,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		96227
	],
	"./pages/technologies/mobile_application_development/HybridApp/XamarinApp.tsx": [
		96227,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		96227
	],
	"./pages/technologies/mobile_application_development/Ios": [
		19863,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19863
	],
	"./pages/technologies/mobile_application_development/Ios.tsx": [
		19863,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19863
	],
	"./pages/technologies/mobile_application_development/Kotlin": [
		16753,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16753
	],
	"./pages/technologies/mobile_application_development/Kotlin.tsx": [
		16753,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		16753
	],
	"./pages/technologies/mobile_application_development/MobileApplicationDevelopment": [
		39549,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		39549
	],
	"./pages/technologies/mobile_application_development/MobileApplicationDevelopment.tsx": [
		39549,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		39549
	],
	"./pages/technologies/mobile_application_development/MobileMaintenanceSupport": [
		58702,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		58702
	],
	"./pages/technologies/mobile_application_development/MobileMaintenanceSupport.tsx": [
		58702,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		58702
	],
	"./pages/technologies/mobile_application_development/PWAS": [
		48633,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49267,
		48633
	],
	"./pages/technologies/mobile_application_development/PWAS.tsx": [
		48633,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49267,
		48633
	],
	"./pages/technologies/web_application_development/AngularJS": [
		96933,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		96933
	],
	"./pages/technologies/web_application_development/AngularJS.tsx": [
		96933,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		96933
	],
	"./pages/technologies/web_application_development/CakePHP": [
		4646,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		4646
	],
	"./pages/technologies/web_application_development/CakePHP.tsx": [
		4646,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		4646
	],
	"./pages/technologies/web_application_development/CodeIgniter": [
		25111,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		25111
	],
	"./pages/technologies/web_application_development/CodeIgniter.tsx": [
		25111,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		25111
	],
	"./pages/technologies/web_application_development/DotNet": [
		214,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		214
	],
	"./pages/technologies/web_application_development/DotNet.tsx": [
		214,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		214
	],
	"./pages/technologies/web_application_development/ExpressJS": [
		11871,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		11871
	],
	"./pages/technologies/web_application_development/ExpressJS.tsx": [
		11871,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		11871
	],
	"./pages/technologies/web_application_development/Java": [
		35540,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		35540
	],
	"./pages/technologies/web_application_development/Java.tsx": [
		35540,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		35540
	],
	"./pages/technologies/web_application_development/KnockoutJS": [
		4813,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		4813
	],
	"./pages/technologies/web_application_development/KnockoutJS.tsx": [
		4813,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		4813
	],
	"./pages/technologies/web_application_development/Laravel": [
		66225,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		66225
	],
	"./pages/technologies/web_application_development/Laravel.tsx": [
		66225,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		66225
	],
	"./pages/technologies/web_application_development/MEAN": [
		6143,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		6143
	],
	"./pages/technologies/web_application_development/MEAN.tsx": [
		6143,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		6143
	],
	"./pages/technologies/web_application_development/Mern": [
		30286,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30286
	],
	"./pages/technologies/web_application_development/Mern.tsx": [
		30286,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		30286
	],
	"./pages/technologies/web_application_development/MeteorJS": [
		57189,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		57189
	],
	"./pages/technologies/web_application_development/MeteorJS.tsx": [
		57189,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		57189
	],
	"./pages/technologies/web_application_development/NodeJS": [
		42177,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		42177
	],
	"./pages/technologies/web_application_development/NodeJS.tsx": [
		42177,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		42177
	],
	"./pages/technologies/web_application_development/Php": [
		58130,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		58130
	],
	"./pages/technologies/web_application_development/Php.tsx": [
		58130,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		58130
	],
	"./pages/technologies/web_application_development/Python": [
		49258,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49258
	],
	"./pages/technologies/web_application_development/Python.tsx": [
		49258,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		49258
	],
	"./pages/technologies/web_application_development/ReactJS": [
		47294,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47294
	],
	"./pages/technologies/web_application_development/ReactJS.tsx": [
		47294,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		47294
	],
	"./pages/technologies/web_application_development/Salesforce": [
		27505,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		27505
	],
	"./pages/technologies/web_application_development/Salesforce.tsx": [
		27505,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		27505
	],
	"./pages/technologies/web_application_development/Sharepoint": [
		93653,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		93653
	],
	"./pages/technologies/web_application_development/Sharepoint.tsx": [
		93653,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		93653
	],
	"./pages/technologies/web_application_development/VueJS": [
		56171,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		56171
	],
	"./pages/technologies/web_application_development/VueJS.tsx": [
		56171,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		75202,
		56171
	],
	"./pages/technologies/web_application_development/WebApplicationDevelopment": [
		19149,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19149
	],
	"./pages/technologies/web_application_development/WebApplicationDevelopment.tsx": [
		19149,
		9,
		96213,
		71378,
		94528,
		34462,
		55262,
		41444,
		19149
	],
	"./serviceWorkerRegistration": [
		79668,
		9
	],
	"./serviceWorkerRegistration.js": [
		79668,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;